import { DeleteOutlined, EditOutlined,UploadOutlined, FileTextOutlined, MinusCircleOutlined, PlusOutlined, QuestionCircleOutlined, ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import { Form, Input, Table, Flex, Button, DatePicker, DatePickerProps, Space, Select, Radio, RadioChangeEvent, Grid, Row, Col, TableProps, Modal, Checkbox, FormProps, GetProp, Card, notification, theme, message, Steps, InputNumber, Tooltip, FloatButton, Popover, Empty, AutoComplete, AutoCompleteProps, UploadProps, UploadFile, Upload, List } from "antd";
import { SearchProps } from "antd/es/input";
import axios, { all } from "axios";
import { JSXElementConstructor, ReactElement, ReactNode, ReactPortal, SetStateAction, useEffect, useRef, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { EducationInterface } from "../models/IEducation";
import { BudgetRequestInterface } from "../models/IBudgetRequest";
import { ResearchHistInterface } from "../models/IResearchHist";
import { PublishedInterface } from "../models/IPub";
import { Tabs } from 'antd';
import { researcherInterface } from "../models/IUserData";
import { JoinDataInterface, joinedParticipantInterface } from "../models/IjoinedResearcher";
import { headDataInterface } from "../models/IHeadData";
import { AboutResearchInterface } from "../models/IAboutResearch";
import { ProfInterface } from "../models/Iprofess";
import { EmployeeInFacInterface, FacilityInterface } from "../models/IShowUser";
import React from "react";



interface Tab {
  key: string;
  label: string;
  children: React.ReactNode;
}
type TargetKey = React.MouseEvent | React.KeyboardEvent | string;

export function BudgetReqResearcher(){
    const [open, setOpen] = useState(false);


    const [form] = Form.useForm();
    const [subform] = Form.useForm();

    const [AcaPos,setAcaPos] = useState('อื่นๆ');
    
    const [loading, setLoading] = useState(false);
    const [success,setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [edit,setedit] = useState(false)

    const [options, setOptions] = React.useState<AutoCompleteProps['options']>([]);
    
    //modal
    const [delResModal,setDelResModal] = useState(false);
    const [delAcaModal,setDelAcaModal] = useState(false);
    const [openPub,setPub] = useState(false);
    const [openjoinRes,setJoinRes] = useState(false);
    const [opensearch,setSearch] = useState(false)
    const [openjoinaca,setJoinAca] = useState(false);
    const [delsubResModal,setDelsubResModal] = useState(false);
    const [delsubAcaModal,setDelsubAcaModal] = useState(false);
    const [notInteger,setIsnotInteger] = useState(false);
    const [isYearexist,setisYearexist] = useState(false);
    const [back,setback] = useState(false);
    
    const [tmpheadjoinper,settmpheadjoinper] = useState(0);
    const [sumJoinPer,setSumJoinPer] = useState(0);

   const newTabIndex = useRef(0);


   //แนบไฟล์สำหรับนศ
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [filename,setFilename] = useState('')
  const [openfile,setOpenFile] = useState(false)
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);


  //  โปรเจ็คหลักมีนักวิจัยร่วมหรือไม่
   const [participantcheck,setparticipantcheck] = useState(false);
  // งานวิจัยเดิมมีนักวิจัยร่วมหรือไม่
   const [tmpparticipantcheck,setTmpparticipantcheck] = useState(false);
  // ค้นหานักวิจัยพบหรือไม่
   const [searchparticipantcheck,setsearchparticipantcheck] = useState(false)
  // บันทึกข้อมูลนักวิจัยสำเร็จหรือไม่
   const [tmpparticipantshow,settmpparticipantshow] =useState(false)
  //  หาไม่เจอให้ขึ้น
   const [participantchecknull,setparticipantChecknull]=useState(false)
  // นั่นคุณเอง
  const [yourself,setYourself]=useState(false)
  //ไม่อยู่ระจ้า
  const [Notexisted,setNotexisted] = useState(false);

  //แผนกงาน
  const [Fac,setFac] = useState<FacilityInterface[]>([]);
  const [FacOp,setFacOp] = useState<FacilityInterface>();
  const [SelectedResOp,setSelectedResOp] = useState<EmployeeInFacInterface>();
  //บุคคล
  const [ResOp,setResOp] = useState<EmployeeInFacInterface[]>([]);
  //เลือกแผนกงาน
  const [SelectedOp,setSelectedOp] = useState('');
  const [prof,setprofess] = useState(null);
  //หาที่ปรึกษาโครงการไม่เจอ
  const [profnotfound,setprofnotfound] = useState(false);
  //ห้ามเพิ่มตัวเองเป็นที่ปรึกษาโครงการ
  const [notselfprof,setnotselfprof] = useState(false);
  //พบที่ปรึกษาโครงการ
  const [foundprof,setfoundprof] = useState(false);


  //ข้อมูลที่ดึงมาจากหลังบ้าน
  const [HeadData,setHeadData] = useState<headDataInterface>();

  // ข้อมูลการศึกษา
    const [education,setEducation] = useState<EducationInterface[]>([])
  //ข้อมูลให้เลือก หัวหน้า
    const [resHis,setResHis] = useState<ResearchHistInterface[]>([])
    const [JoinedRes,setJoinedRes] = useState<ResearchHistInterface[]>([])
    const [acaHis,setAcaHis] = useState<PublishedInterface[]>([])

    //ข้อมูลที่เลือกหัวหน้า
    const [selectedreshis,setSelectedResHis] = useState<ResearchHistInterface[]>([])
    const [selectedAcaHis,setSelectedAcaHis] = useState<PublishedInterface[]>([])
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [User,setUser] = useState<researcherInterface>();
    const [headdata_exist,setheaddata_exist] = useState(false)
    
 
    const [addResHis,setaddResHis] = useState(false);

    const beforeUpload = (file : any) => {
      const encodedFileName = encodeURIComponent(file.name);
      const newFile = new File([file], encodedFileName, { type: file.type });
      const isPDF = file.type === 'application/pdf';
      if (!isPDF) {
        message.error('โปรดอัพโหลดไฟล์ PDF เท่านั้น');
        return Upload.LIST_IGNORE;
      }
      return newFile;
    }

    const fetchFiles = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE}/Studentfiles/${project_id}`);
        const files = response.data.map((file: any) => ({
          uid: file.uid || `__AUTO__${file.uid}`, // Ensure each file has a unique uid
          name: decodeURIComponent(atob(file.Filename)), // Decode the filename
          status: 'done', // Mark the file as already uploaded
          url: `${process.env.REACT_APP_BASE}/get_pdf/${file.uid}`, 
          preview: file.Data
        }));
        setFileList(files);
        console.log(files)
      } catch (error) {
        console.error('Error fetching file list:', error);
      }
    };

    const DownloadHandle = async (fileName: any) => {
      try {
        // Make API call to get the PDF data
        const response = await axios.get(`${process.env.REACT_APP_BASE}/get_pdf/${fileName}/${project_id}`, {
          responseType: 'blob', // This is crucial for handling binary data
        });
  
        // Create a Blob from the response
        const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
  
        // Create a URL for the Blob
        const pdfUrl = window.URL.createObjectURL(pdfBlob);
  
        // Create a link to download the PDF
        const link = document.createElement('a');
        link.href = pdfUrl;
  
        // Extract the filename from the Content-Disposition header
        const contentDisposition = response.headers['content-disposition'];
        let name = 'downloaded-file.pdf'; // Fallback filename
  
        if (contentDisposition) {
          const filenameRegex = /filename[^*=]*=((['"]).*?\2|([^;\s]*))/; 
          const matches = filenameRegex.exec(contentDisposition);
          if (matches != null && matches[1]) {
            name = matches[1].replace(/['"]/g, ''); // Remove quotes if present
          }
        }
  
        link.setAttribute('download', name); // Set the filename
  
        // Append link to body and trigger click to download
        document.body.appendChild(link);
        link.click();
  
        // Cleanup: remove link and release object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(pdfUrl);
  
        if(response.status === 200){
          message.success('Download File successfully');
        }else{
          message.error('ERROR, Download File unsuccessfully');
        }
  
        message.success('PDF downloaded successfully!');
      } catch (error) {
        console.error('Error downloading PDF:', error);
        message.error('Failed to download PDF.');
      } finally {
        setLoading(false);
      }
      
    };
  
    const handleRemove = (uid: string,filename:any) => {
      setFileList((prevFileList) => prevFileList.filter(file => file.fileName !== uid));
      message.success('File removed successfully.');
      axios.delete(`${process.env.REACT_APP_BASE}/delPDF/${uid}/${project_id}`).then(Response=>
        {if(Response.status==200){
          fetchFiles();
        }}
      )
    };

    
    
    const handlePreview = (file: UploadFile) => {
      if (file.preview && (file.preview as any).data) {
        // Access the data array from the preview buffer
        const uint8Array = new Uint8Array((file.preview as any).data);
        const blob = new Blob([uint8Array], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
    
        setPreviewUrl(blobUrl);
        setOpenFile(true);  // Open the modal
      } else {
        console.error("Preview data not found.");
      }
    };

    //ข้อมูลtmp

    //ข้อมูลผู้ร่วมวิจัย
    //ดึง
    const [tmpid,settmpid]=useState('')
    const [tmpResearcher,settmpResearcher] = useState<researcherInterface>()
    const [tmpprof,settmpprof]=useState<researcherInterface>()
    const [settmpeditjoinper,setedittmpjoinper] = useState(0);
    const [tmpEdu,settmpEdu] = useState<EducationInterface[]>([])
    const [tmpResHis,settmpResHis] = useState<ResearchHistInterface[]>([])
    const [tmpjoinedResHis,settmpjoinedResHis] = useState<ResearchHistInterface[]>([])
    const [tmpaca,settmpAca] = useState<PublishedInterface[]>([])

    //เลือก
    const [selectedtmpResHis,setselectedtmpResHis] = useState<ResearchHistInterface[]>([])
    const [selectedTMPaca,setselectedtmpaca] = useState<PublishedInterface[]>([])
    
    const [tmpArrayResearcher,setTmpArrayResearcher] = useState<researcherInterface[]>([])
    
    const [joinParticipant,setJoinParticipant] = useState<joinedParticipantInterface[]>([])

    const [head_wp,sethead_wp] = useState('')
    const [prodata,setprodata] = useState<AboutResearchInterface>();
    const [clicked, setClicked] = useState(false);
    const [hovered, setHovered] = useState(false);

    const { token } = theme.useToken();
    const [current, setCurrent] = useState(0);
    const { project_id } = useParams();
    const navigate = useNavigate();
    const hide = () => {
      setClicked(false);
      setHovered(false);
    };
  
    const handleHoverChange = (open: boolean) => {
      setHovered(open);
      setClicked(false);
    };
  
    const handleClickChange = (open: boolean) => {
      setHovered(false);
      setClicked(open);
    };
  
    const hoverContent = <div>
      <Flex>
      <p>
      <strong>อัตราสัดส่วนงานวิจัยรวม :</strong></p>{(sumJoinPer!=100)&&<p style={{color:'red'}}>{sumJoinPer}</p>
      ||<p>{sumJoinPer}</p>}
      
      </Flex>
      <p>
      <strong>อัตราสัดส่วนงานวิจัยของหัวหน้าวิจัย :</strong>{tmpheadjoinper}</p>
      <p>
      <strong>อัตราสัดส่วนงานวิจัยของผู้ร่วมวิจัย :</strong>{sumJoinPer-tmpheadjoinper}</p>
      {joinParticipant.map((data,index)=>(
        <>
        <hr/>
        <p><strong>ข้อมูลผู้ร่วมวิจัยคนที่ {index+1}</strong></p>
        <p><strong>ชื่อ :</strong> {data.head_name_th}</p>
        <p><strong>สัดส่วนการเข้าร่วมโครงการวิจัย :</strong> {data.join_per}</p>
        
        </>
      ))}
      </div>;
    const clickContent = <div>
      <Flex>
      <p>
      <strong>อัตราสัดส่วนงานวิจัยรวม :</strong></p>{(sumJoinPer!=100)&&<p style={{color:'red'}}>{sumJoinPer}</p>
      ||<p>{sumJoinPer}</p>}
      
      </Flex>
      <p>
      <strong>อัตราสัดส่วนงานวิจัยของหัวหน้าวิจัย :</strong>{tmpheadjoinper}</p>
      <p>
      <strong>อัตราสัดส่วนงานวิจัยของผู้ร่วมวิจัย :</strong>{sumJoinPer-tmpheadjoinper}</p>
      {joinParticipant.map((data,index)=>(
        <>
        <hr/>
        <p><strong>ข้อมูลผู้ร่วมวิจัยคนที่ {index+1}</strong></p>
        <p><strong>ชื่อ :</strong> {data.head_name_th}</p>
        <p><strong>สัดส่วนการเข้าร่วมโครงการวิจัย :</strong> {data.join_per}</p>
        
        </>
      ))}
      </div>;



const props: UploadProps = {
  name: 'file',
  accept: ".pdf",
  action: `${process.env.REACT_APP_BASE}/upload_StudentListpdf/${project_id}`,
  multiple: true,
  listType: "text",
  showUploadList: true,
  onChange(info) {
    const updatedFileList = [...fileList];
    const { file, fileList: newFileList } = info;

    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`);
      fetchFiles();
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
  onPreview(file) { // Add onPreview for downloading
    const downloadLink = document.createElement('a');
    downloadLink.href = file.url || `${process.env.REACT_APP_BASE}/get_pdf/${file.response.fileName}`;
    downloadLink.download = file.name;
    downloadLink.click();
  },
  progress: {
    strokeColor: {
      '0%': '#108ee9',
      '100%': '#87d068',
    },
    
    strokeWidth: 3,
    format: (percent) => percent && `${parseFloat(percent.toFixed(2))}%`,
  },
};

  const handleChange = (value: any) =>{
    setSelectedOp(value);
    const selected = Fac.find((facility) => facility.Fac_ID === value);
    if (selected) {
      setFacOp(selected);
      console.log('Selected Facility:', { Fac_ID: selected.Fac_ID, Fac_NameTH: selected.Fac_NameTH });
    }
    axios.get(`https://i.vu.ac.th/digitalId/vuapiver1/vu/select_fac_worker.php?facid=${value}`)
    .then(res=>{
      const user = sessionStorage.getItem('user'); // Get the value of 'user' from sessionStorage
      const filteredData = res.data.filter((item: any) => item.id !== user); // Exclude matching entry
      setResOp(filteredData); // Set the filtered data
      setResOp(res.data)
      setSelectedResOp(undefined)
    })
  }

  const handleProfChange = (value: any) =>{
    setprofess(value)
    const selected = ResOp.find((committee) => committee.WK_ID === value);
    if (selected) {
      setSelectedResOp(selected);
    }
  }

  const DeleteParticipant = async(value:any) =>{
    console.log(value)
    try{axios.delete(`${process.env.REACT_APP_BASE}/deleteResearcher/${project_id}/${value.head_id}`).then(
      res=>{
        console.log('deleted',res)
        axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${project_id}/${sessionStorage.getItem('user')}`).then(response=>{
          if(response.data){
            setJoinParticipant(response.data.subInfo); 
            console.log(Number(value.join_per))
            setSumJoinPer(Number(sumJoinPer)-Number(value.join_per))
            setparticipantcheck(true)
          }else{
            setparticipantcheck(false)
          }
        })
      }
    )}catch(error){
      notification.error({
        message:"บันทึกข้อมูลไม่สำเร็จ",
      })}
    
  }
  const handleSelectAll = (e: { target: { checked: any; }; }) => {
    if (e.target.checked) {
      // Select all items in `resHis` if "Select All" checkbox is checked
      setSelectedResHis(prevSelected => [
        ...prevSelected,
        ...resHis.filter(item => 
          !prevSelected.some(selected => selected.project_id === item.project_id))
        .map(item => ({ ...item, role: 'หัวหน้าโครงการวิจัย' }))
      ]);
    } else {
      // Deselect only items that are in `resHis`
      setSelectedResHis(prevSelected =>
        prevSelected.filter(selected => !resHis.some(item => item.project_id === selected.project_id))
      );
    }
  };
  

    function refreshTable(user:any,part:any,role:any){
      let tempedu: SetStateAction<EducationInterface[]> =[]
      if(role=='head'){
        axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${sessionStorage.getItem('user')}`).then(res =>{
            if(part=='res'){
              setResHis(res.data.projectResult)
            }else if(part=='aca'){
              setAcaHis(res.data.academicResult)
            }
          })
      }else if(role=='joined'){
        axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${user}`).then(res =>{
            if(part=='res'){
              settmpResHis(res.data.projectResult)
              settmpjoinedResHis(res.data.joinResult)
            }else if(part=='aca'){
              settmpAca(res.data.academicResult)
            }
          })
      }
      
    }
    const getInfoResearcher = async()=>{
      let tempedu: SetStateAction<EducationInterface[]> =[]
      axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${sessionStorage.getItem('user')}`).then(res =>{
      // axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${local_researcher}`).then(response =>{
        console.log(res.data)
        setUser(res.data.userResult[0])
        tempedu = res.data.eduResult;
        console.log(res.data.eduResult)
        
        setEducation(res.data.eduResult)
        setResHis(res.data.projectResult)
        setJoinedRes(res.data.joinResult)
        setAcaHis(res.data.academicResult)
        console.log(res.data.eduResult)
      }).then(()=>{
        axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${project_id}/${sessionStorage.getItem('user')}`).then(response =>{
          //pro
          console.log(response.data)
          setprodata(response.data.main[0])
          form.setFieldsValue(response.data.main[0]);
          
          if(response.data.main[0].pro_position=='ศาสตราจารย์'
            || response.data.main[0].pro_position=='รองศาสตราจารย์'
            || response.data.main[0].pro_position=='ผู้ช่วยศาสตราจารย์'
            || response.data.main[0].pro_position=='อาจารย์'
          )
          {setAcaPos(response.data.main[0].pro_position)}
          else{
            setAcaPos("อื่นๆ")
            console.log('test')
          }
          //head
          if(response.data.head_researcher[0]){
            console.log(`its here`)
            setheaddata_exist(true)
            form.setFieldsValue(response.data.head_researcher[0]);
            console.log(form.getFieldValue)
            settmpheadjoinper(response.data.head_researcher[0].join_per)
            setSumJoinPer(response.data.head_researcher[0].join_per)
            console.log(JSON.parse(response.data.head_researcher[0].head_edu))
            setisYearexist(true);
            setSelectedResHis(JSON.parse(response.data.head_researcher[0].head_res))
            tmpaca.push(JSON.parse(response.data.head_researcher[0].head_pub))
            console.log(JSON.parse(response.data.head_researcher[0].head_pub))
            setSelectedAcaHis(JSON.parse(response.data.head_researcher[0].head_pub))
            // sub
            
            if (response.data.subInfo.length > 0) {
              console.log(response.data.subInfo);
              setJoinParticipant(response.data.subInfo);
              setparticipantcheck(true);
            
              // Calculate the sum of join_per values
              let sum = response.data.subInfo.reduce((acc: any, item: { join_per: any; }) => {
                return Number(acc) + (Number(item.join_per) || 0); // Ensure join_per is a number
              }, 0);
              console.log(sum)
              setSumJoinPer(sum+Number(response.data.head_researcher[0].join_per));
            } else {
              setparticipantcheck(false);
            }
            
          }else{
            setisYearexist(false);
            setheaddata_exist(false)
          }

          if(response.data.main[0].budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'){
            fetchFiles();
          }
        })
      })
    

      
    }

    const [activeKey, setActiveKey] = useState('1');
    const [tabs, setTabs] = useState<Tab[]>([]);

    const editParticipant = (value: any) => {
      console.log(value)
      // Populate the form with the participant's current values
      axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${value.head_id}`).then(
        response=>{
          if(!response.data){
            setparticipantChecknull(true)
            setsearchparticipantcheck(false)
            settmpResearcher(undefined)
            setIsnotInteger(false)
          }else{
            setparticipantChecknull(false)
            settmpResearcher(response.data.userResult[0])
            settmpResHis(response.data.projectResult)
            settmpjoinedResHis(response.data.joinResult)
            settmpAca(response.data.academicResult)
            setIsnotInteger(false)
            setsearchparticipantcheck(true)
            setedittmpjoinper(value.join_per)
          }
        }
      )
      subform.setFieldsValue({
        join_per: value.join_per,
        wp: value.head_wp,
        edu_level: value.head_edu ? JSON.parse(value.head_edu) : [],
      });
      setSumJoinPer(sumJoinPer-value.join_per)
      settmpEdu(value.head_edu ? JSON.parse(value.head_edu) : [])
      setselectedtmpResHis(value.head_res ? JSON.parse(value.head_res) : [])
      setselectedtmpaca(value.head_pub ? JSON.parse(value.head_pub) : [])
      setaddResHis(true); // Show the form
    };

    const handleAddSearchParticipant = (value : any) =>{  
      setaddResHis(true)
      setsearchparticipantcheck(false)
      settmpResearcher(value)
      console.log(value)
    }
    const remove = (targetKey: TargetKey) => {
      let newActiveKey = activeKey;
      let lastIndex = -1;
      tabs.forEach((item, i) => {
        if (item.key === targetKey) {
          lastIndex = i - 1;
        }
      });
      const newPanes = tabs.filter((item) => item.key !== targetKey);
      if (newPanes.length && newActiveKey === targetKey) {
        if (lastIndex >= 0) {
          newActiveKey = newPanes[lastIndex].key;
        } else {
          newActiveKey = newPanes[0].key;
        }
      }
      setTabs(newPanes);
      setActiveKey(newActiveKey);
    };

    
    const handleParticipantChange = (e: RadioChangeEvent)=>{
      const value = e.target.value;
      setparticipantcheck(value)
      if(!value){
        settmpResearcher(undefined);
        setselectedtmpResHis([]);
      }
    }

    const next = () => {
      setCurrent(current + 1);
      console.log(education)
    };
  
    const prev = () => {
      setCurrent(current - 1);
    };

    
    const contentStyle: React.CSSProperties = {
      lineHeight: '50px',
      // textAlign: 'center',
      backgroundColor: token.colorFillAlter,
      borderRadius: token.borderRadiusLG,
      border: `1px dashed ${token.colorBorder}`,
      marginTop: 16,
    };

    const searchResearcher = async(value: any) =>{
      setaddResHis(false);
      if(Number.isInteger(Number(value.WK_ID)) && value.WK_ID !== null && value.WK_ID !== sessionStorage.getItem('user')){
        axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${value.WK_ID}`).then(response=>{
          if(!response.data){
            setparticipantChecknull(true)
            setsearchparticipantcheck(false)
            settmpResearcher(undefined)
            setIsnotInteger(false)
            setYourself(false);
            setNotexisted(false)
          }else{
            if(response.data.userResult.length>0)
              { 
                settmpid(value.WK_ID)
                setparticipantChecknull(false)
                settmpResearcher(response.data.userResult[0])
                settmpEdu(response.data.eduResult)
                settmpResHis(response.data.projectResult)
                settmpjoinedResHis(response.data.joinResult)
                settmpAca(response.data.academicResult)
                console.log(response.data.academicResult)
                setIsnotInteger(false)
                setsearchparticipantcheck(true)
                setNotexisted(false)
                setYourself(false);
              }
              else{
                setYourself(false);
                setparticipantChecknull(false)
                setsearchparticipantcheck(false)
                settmpResearcher(undefined)
                setIsnotInteger(false)
                setNotexisted(true)
              }
          }
        }
          
        )
      }else if(value.WK_ID == sessionStorage.getItem('user'))
        {
          setYourself(true);
          setparticipantChecknull(false)
          setsearchparticipantcheck(false)
          settmpResearcher(undefined)
          setIsnotInteger(false)
          setNotexisted(false)
        }
      else
      {
        setparticipantChecknull(false)
        setIsnotInteger(true)
        setsearchparticipantcheck(false)
        settmpResearcher(undefined)
        setNotexisted(false)
      }
      
    }

    const searchProf = async(value:any)=>{
      axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${value.ID}`).then(response=>{
        if(!response.data||response.data.userResult.length==0){
          setprofnotfound(true);
          setnotselfprof(false);
          setfoundprof(false)
          settmpprof(undefined);
        }else if(value.ID == sessionStorage.getItem('user')){
          setnotselfprof(true);
          setprofnotfound(false);
          setfoundprof(false)
          settmpprof(undefined);

        }else{
          setnotselfprof(false);
          setprofnotfound(false);
          setfoundprof(true)
          settmpprof(response.data);
        }
      }

      )
    }

    const setProf = async(value:any)=>{
      form.setFieldsValue({
        pro_name: prof,
        pro_position: "", 
        pro_wp: "มหาวิทยาลัยวงษ์ชวลิตกุล",
      });
      setSearch(false);
    }

    
    

    const showModal = () => {
      setOpen(true);
    };
    const showDelResModal = () =>{
      setDelResModal(true);

    }
    const showDeljoinResModal = () =>{
      setDelsubResModal(true);

    }
    const showDelAcaModal = ()=>{
      setDelAcaModal(true);
    }
    const showPubModal = () =>{
      setPub(true)
    }
 

      //เลือกปีพ.ศ.
    const onChange: DatePickerProps['onChange'] = (date, dateString) => {
        console.log(date, dateString);
      };

    
    const HandleHead : FormProps<headDataInterface>['onFinish']= (value) =>{
      console.log(value);
      let selectedAca = JSON.stringify(selectedAcaHis);
      let selectedRes = JSON.stringify(selectedreshis);
      console.log(selectedAcaHis)
      console.log(selectedreshis)
      const edu = JSON.stringify(education);
 
      const data = {
        part: 'part2.2',
        head_researcher_id: sessionStorage.getItem('user'),
        head_name_th: `${User?.Per_PrefixTH} ${User?.Per_FNameTH} ${User?.Per_LNameTH}`,
        head_name_en: `${User?.Per_PrefixEN} ${User?.Per_FNameEN} ${User?.Per_LNameEN}`,
        head_wp : value.head_wp,
        head_email : value.head_email,
        head_edu : edu,
        head_ex : selectedRes,
        head_pub : selectedAca,
        join_per : value.join_per||100,
        role : 'head-reseacher'
      }
      settmpheadjoinper(value.join_per)
      if(joinParticipant.length>0){
        let tmpper = sumJoinPer-tmpheadjoinper;
        setSumJoinPer(Number(tmpper)+Number(value.join_per));
        settmpheadjoinper(value.join_per)
      }else{
        setSumJoinPer(value.join_per);
      }

      try{
          console.log('patching')
          axios.patch(`${process.env.REACT_APP_BASE}/UpdateBudgetReq/${project_id}`, data)
          .then((response)=>{
            if (response.status === 200) {
              console.log("บันทึกสำเร็จ")
              setSuccess(true);
              console.log(response);
              setSuccess(true);
              next();
            }
          })
      }catch(error) {
        notification.error({
          message: "บันทึกข้อมูลไม่สำเร็จ",
        });
      }
    }

    const handleSearch = (value: string) => {
      setOptions(() => {
      if (!value || value.includes('@')) {
          return [];
      }
      return ['gmail.com', 
              'yahoo.com', 
              'hotmail.com', 
              'outlook.com', 
          ].map((domain) => ({
          label: `${value}@${domain}`,
          value: `${value}@${domain}`,
      }));
      });
  };

    

    const handleOk = () => {
      setOpen(false);
      setPub(false);
      setDelResModal(false)
      setDelAcaModal(false)
      setJoinRes(false)
      setJoinAca(false)
      setDelsubResModal(false)
      setDelsubAcaModal(false)
    };

    const handledelok= (value: number) =>{
      console.log(value)
      setSelectedAcaHis(selectedAcaHis.filter(item => item.academic_id !== value));
      handleCancel();
    }


    const handlePubOk = () =>{
      setOpen(false);
      setPub(false);
      setDelResModal(false);
      setDelAcaModal(false);
    }
    
    const handlesubDel = (value:number)=>{
      setselectedtmpResHis(selectedtmpResHis.filter(item => item.project_id !== value));
      handleOk();
      handleCancel();
    }



    const handleDelRes = (value: number) =>{
      console.log(value)
      setSelectedResHis(selectedreshis.filter(item => item.project_id !== value));
      handleOk();
      handleCancel();
    }

    const handleDelsubPubRes = (value: number) =>{
      console.log(value)
      setselectedtmpaca(selectedTMPaca.filter(item => item.academic_id !== value));
      handleOk();
      handleCancel();
    }
  
    const handleCancel = () => {
      setOpen(false);
      setPub(false);
      setDelResModal(false);
      setDelAcaModal(false);
      setprofnotfound(false);

      setSearch(false);
      setJoinRes(false);
      setJoinAca(false);
      setDelsubAcaModal(false)
      setDelsubResModal(false)

      setTmpparticipantcheck(false);
      setparticipantChecknull(false)
      setsearchparticipantcheck(false)
      settmpparticipantshow(false)
    };

    const handleMainInfo = () =>{
      navigate(`/VRIIS/BudgetReqInfo/${project_id}`)
  }
  const handleNextPart = () =>{
      navigate(`/VRIIS/BudgetReqDetail/${project_id}`)
  }
  const handleCheckboxChange = (record: ResearchHistInterface) => {
    const alreadySelected = selectedreshis.find(item => item.project_id === record.project_id);
    if (alreadySelected) {
      setSelectedResHis(selectedreshis.filter(item => item.project_id !== record.project_id));
    } else {
      setSelectedResHis([...selectedreshis, record]);
    }
  };

  const handleJoinCheckboxChange = (record: ResearchHistInterface) => {
    const alreadySelected = selectedtmpResHis.find(item => item.project_id === record.project_id);
    if (alreadySelected) {
      setselectedtmpResHis(selectedtmpResHis.filter(item => item.project_id !== record.project_id));
    } else {
      setselectedtmpResHis([...selectedtmpResHis, record]);
    }
  }

  const handleAcaCheckboxChange = (record: PublishedInterface)=>{
    const alreadySelected = selectedAcaHis.find(item => item.academic_id === record.academic_id);
    if (alreadySelected) {
      setSelectedAcaHis(selectedAcaHis.filter(item => item.academic_id !== record.academic_id));
    } else {
      setSelectedAcaHis([...selectedAcaHis, record]);
    }
  }

  const handleResCheckboxChange = (record: PublishedInterface)=>{
    const alreadySelected = selectedTMPaca.find(item => item.academic_id === record.academic_id);
    if (alreadySelected) {
      setselectedtmpaca(selectedTMPaca.filter(item => item.academic_id !== record.academic_id));
    } else {
      setselectedtmpaca([...selectedTMPaca, record]);
    }
  }
  
    const academicHis : TableProps<PublishedInterface>['columns']=[
      {
        title: 'ปีที่พิมพ์',
        dataIndex:'year',
        key: 'year'
    },{
      title: 'ชื่อบทความทางวิชาการ',
      dataIndex:'academic_name',
      key: 'academic_name'
  },{
    title: 'ชื่อบทความทางวิชาการภาษาอังกฤษ',
    dataIndex:'academic_en_name',
    key: 'academic_en_name'
},
    {
      title: 'ประเภทสิ่งตีพิมพ์',
      dataIndex:'academic_datebase',
      key: 'academic_datebase'
    },
    {
      title: (<Checkbox
        onChange={(e) => {
          if (e.target.checked) {
            // Select all items, but keep already selected items
            setSelectedAcaHis(prevSelected => [
              ...prevSelected,
              ...acaHis.filter(item => !prevSelected.some(selected => selected.academic_id === item.academic_id))
            ]);
          } else {
            // Deselect all items
            setSelectedAcaHis(prevSelected =>
              prevSelected.filter(selected => !acaHis.some(item => item.academic_id === selected.academic_id))
            );
          }
        }}
        checked={acaHis.every((item) => selectedAcaHis.some(selected=>selected.academic_id === item.academic_id))}
        indeterminate={
          selectedAcaHis.length > 0 &&
          selectedAcaHis.length < acaHis.length &&
          acaHis.some((item) => selectedAcaHis.includes(item))
        }
      >
        <p style={{color:'white'}}>เลือกโครงการทั้งหมด</p>
      </Checkbox>),
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
            <Checkbox
              onChange={()=>handleAcaCheckboxChange(record)}
              checked={selectedAcaHis.some(item=>item.academic_id===record.academic_id)}
            />
        </Space>
      ),
    },
      
    ]

    const academicJoinHis : TableProps<PublishedInterface>['columns']=[
          {
            title: 'ปีที่พิมพ์',
            dataIndex:'year',
            key: 'year'
        },{
          title: 'ชื่อบทความทางวิชาการ',
          dataIndex:'academic_name',
          key: 'academic_name'
      },{
        title: 'ชื่อบทความทางวิชาการภาษาอังกฤษ',
        dataIndex: 'academic_en_name',
        key: 'academic_en_name'
      },
    {
      title: 'ประเภทสิ่งตีพิมพ์',
      dataIndex:'academic_datebase',
      key: 'academic_datebase'
    },
    {
      title: (<Checkbox
        onChange={(e) => {
          if (e.target.checked) {
            // Select all items, but keep already selected items
            setselectedtmpaca(prevSelected => [
              ...prevSelected,
              ...tmpaca.filter(item => !prevSelected.some(selected => selected.academic_id === item.academic_id))
            ]);
          } else {
            // Deselect all items
            setselectedtmpaca(prevSelected =>
              prevSelected.filter(selected => !tmpaca.some(item => item.academic_id === selected.academic_id))
            );
          }
        }}
        checked={tmpaca.every((item) => selectedTMPaca.some(selected=>selected.academic_id === item.academic_id))}
        indeterminate={
          selectedTMPaca.length > 0 &&
          selectedTMPaca.length < acaHis.length &&
          tmpaca.some((item) => selectedTMPaca.includes(item))
        }
      >
        <p style={{color:'white'}}>เลือกโครงการทั้งหมด</p>
      </Checkbox>),
      key: 'action',
      render: (_, record) => (
        <Space size="middle"> 
            <Checkbox
              onChange={()=>handleResCheckboxChange(record)}
              checked={selectedTMPaca.some(item=>item.academic_id===record.academic_id)}
            />
        </Space>
      ),
    },
          
    ]

   const getFac = async()=>{
      axios.get(`https://i.vu.ac.th/digitalId/vuapiver1/vu/select_faculty.php`).then(res=>{
        setFac(res.data.filter((fac: any) => fac.Fac_ID !== "70"));
      })
    }

    useEffect(()=>{
      getInfoResearcher();
      getFac();
    },[])
    

    
  const onEdit = (
    targetKey : React.MouseEvent | React.KeyboardEvent | string,
    action: 'add' | 'remove',
  ) =>{
    if (action === 'remove'){
      remove(targetKey)
    }
  }

 


  function AddAca(): void {
    setPub(false);
  }


  const StepOnChange = (value: number) => {
    console.log('onChange:', value);
    setCurrent(value);
  };

  function showJoinRes(): void {
    setJoinRes(true);
  }

  const AddHandle: FormProps<JoinDataInterface>['onFinish'] = (values:any) => {
    const edu = JSON.stringify(tmpEdu);
    let selectedAca = JSON.stringify(selectedTMPaca);
    let selectedRes = JSON.stringify(selectedtmpResHis);
    const data = {
      part:'part2.2',
      head_researcher_id: tmpResearcher?.WK_ID,
      head_name_th: `${tmpResearcher?.Per_PrefixTH} ${tmpResearcher?.Per_FNameTH} ${tmpResearcher?.Per_LNameTH}`,
      head_name_en: `${tmpResearcher?.Per_PrefixEN} ${tmpResearcher?.Per_FNameEN} ${tmpResearcher?.Per_LNameEN}`,
      head_wp : values.wp,
      head_edu : edu,
      head_ex : selectedRes,
      head_pub : selectedAca,
      join_per : values.join_per,
      role : 'joined-researcher'
    }
    let tmpJoinper = Number(sumJoinPer);
    tmpJoinper += Number(values.join_per);
    setSumJoinPer(tmpJoinper);
    subform.resetFields();
    console.log(data)

      try{
        axios.patch(`${process.env.REACT_APP_BASE}/UpdateBudgetReq/${project_id}`, data)
        .then((response)=>{
          if (response.status === 200) {
            console.log("บันทึกสำเร็จ")
            setSuccess(true);
            console.log(response);
            setSuccess(true);
            settmpResearcher(undefined);
            settmpEdu([])
            settmpResHis([])
            setselectedtmpResHis([])
            settmpAca([]);
            setselectedtmpaca([])
            setsearchparticipantcheck(false)
            setaddResHis(false)
          }
        }).then(()=>{
          axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${project_id}/${sessionStorage.getItem('user')}`).then(response=>{
            if(response.data){
              setJoinParticipant(response.data.subInfo);
              setparticipantcheck(true)
            }else{
              setparticipantcheck(false)
            }
          })
        })}catch(error){
        notification.error({
          message:"บันทึกข้อมูลไม่สำเร็จ",
        })}
      
    

    
  }

  const handleProfession : FormProps<ProfInterface>['onFinish'] = (values) => {
    console.log(values)
    console.log(Number(sessionStorage.getItem("user")))
    console.log('กำลังกดบันทึก')
    const data = {
      part : 'part2.1',
      pro_name : values.pro_name,
      pro_position: AcaPos === "อื่นๆ" ? values.pro_position : AcaPos,
      pro_wp : values.pro_wp,
      pro_exp : values.pro_exp
    }
      console.log(data)
      
    // return data
    axios 
    .patch(`${process.env.REACT_APP_BASE}/UpdateBudgetReq/${project_id}`, data)
    .then((response) => {
      if (response.status === 200) {
        console.log("บันทึกสำเร็จ")
        setSuccess(true);
        console.log(response);
        setSuccess(true);
        next();
      }
    })
    .catch((error) => {
        setError(true);
        console.log(error)
        console.log(error.response)
        notification.error({
            message: "บันทึกข้อมูลไม่สำเร็จ",
            description: error.response.data.Message,
          });
        setErrorMessage(error.response.data.Message)
    });
}
  

  const steps = [
    {
      title: 'หัวหน้าโครงการวิจัย',
      content: (
        <div>
          {((resHis.length==0&&JoinedRes.length==0)||acaHis.length==0||education.length==0)&&
          <Card
            style={{marginLeft:20,marginTop:20,marginBottom:20,marginRight:20
            }}>
              <Flex><p><u>คำเตือน</u></p> &nbsp; <p> ระบบได้ตรวจสอบพบว่าท่านยังขาดข้อมูลประวัติในระบบ MIS กรุณาเพิ่ม </p><Button type='link'><u>
                <a href="https://i.vu.ac.th/research/" target="_blank">ที่นี่</a></u></Button><p> ข้อมูลก่อนกรอกฟอร์มนี้</p> </Flex>
              {education.length==0&&<><br/><Card style={{backgroundColor:'#F54841'}}>
                <p style={{color:'white'}}>ข้อมูลที่ท่านต้องเพิ่มในระบบ </p>
                <p style={{color:'white',marginLeft:20}}>- ข้อมูลวุฒิการศึกษา</p>
              </Card></>}
              {
                (acaHis.length==0||resHis.length==0)&&
                <><br/>
                <Card style={{backgroundColor:'#F5E898'}}>
                  <p>ข้อมูลที่ท่านไม่มีในระบบ (หากท่านไม่เคยมีงานวิจัยหรืองานตีพิมพ์มาก่อน ท่านไม่ต้องสนใจข้อความนี้ )</p>
                  {(resHis.length==0&&JoinedRes.length==0)&&<p style={{marginLeft:20}}>- ประวัติข้อมูลงานวิจัย</p>}
                  {acaHis.length==0&&<p style={{marginLeft:20}}>- ประวัติข้อมูลงานวิจัยตีพิมพ์</p>}
                </Card>
                </>
              }
            </Card>}
          <h4 className="text-2xl font-bold " style={{marginLeft:10,marginTop:25}}>คณะผู้ดำเนินงานวิจัยสัดส่วนงานวิจัย</h4>
          <h5 className="text-xl font-semibold" style={{marginLeft:20}}>ประวัติหัวหน้าโครงการวิจัย</h5>
          <Form style={{marginBottom:60,marginRight:40,marginLeft:40}} onFinish={HandleHead} form={form}>
            <Form.Item className='font-semibold' label='ชื่อ-สกุล' layout="vertical" >
              <Input className='font-normal'placeholder={`${User?.Per_PrefixTH} ${User?.Per_FNameTH} ${User?.Per_LNameTH}`} disabled value={String(sessionStorage.getItem("fullname"))}/>
            </Form.Item>
            <Form.Item layout="vertical" >
              <Input className='font-normal' style={{marginTop:15}} placeholder={`${User?.Per_PrefixEN} ${User?.Per_FNameEN} ${User?.Per_LNameEN}`} disabled value={`${User?.Per_PrefixEN} ${User?.Per_FNameEN} ${User?.Per_LNameEN}`}/>
            </Form.Item>
            <br/>
            <hr/>
            <br/>
            <Form.Item className='font-semibold' rules={[
                    { required: true, message: 'กรุณากรอกอีเมล' },
                    {
                    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: 'รูปแบบอีเมลไม่ถูกต้อง',
                    },
                ]} label='email' name={'head_email'} style={{marginLeft: '20px'}} >
              <AutoComplete
                onSearch={handleSearch}
                options={options}
                />
            </Form.Item>
            <Form.Item className='font-semibold' label='สถานที่ทำงาน' name={'head_wp'} style={{marginLeft: '20px'}} >
              <Input className='font-normal'/>
            </Form.Item>
            {(joinParticipant.length>0&&sumJoinPer==100)&&<><Card style={{marginBottom:10,backgroundColor:'#F5E898'}}>
              <p className='font-semibold'><u>คำเตือน</u></p>
              <p>ระบบได้ตรวจพบว่าท่านมีสัดส่วนการเข้าร่วมโครงการวิจัยรวมครบ 100 เปอร์เซ็นต์แล้ว</p>
              <p>เพื่อป้องกันไม่ให้สามารถบันทึกค่าเกินได้ ระบบจะทำการล็อคไม่ให้ท่านกรอกสัดส่วนมากกว่าที่กรอกไปแล้ว</p>
              <p>หากต้องการเพิ่มสัดส่วนของท่าน กรุณาลดสัดส่วนการร่วมวิจัยของผู้ร่วมวิจัยลงก่อน</p>
              </Card></>}
            {(sumJoinPer<100&&prodata?.budget_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา')&&<>
              <Card>
                <p>ขณะนี้สัดส่วนการวิจัยรวมของโครงการนี้อยู่ที่ {sumJoinPer} เปอร์เซ็นต์</p>
                <p>โดยมีสัดส่วนการวิจัยของท่านอยู่ที่ {tmpheadjoinper} เปอร์เซ็นต์</p>
                {joinParticipant.length>0&&<><p>
                  และสัดส่วนการวิจัยของผู้ร่วมวิจัยอยู่ที่{" "}
                  {joinParticipant.reduce((acc, data) => acc + (Number(data.join_per) || 0), 0)} เปอร์เซ็นต์
                </p>
                {joinParticipant.map((data,index)=>(
                  <>
                  <hr/>
                  <p><strong>ข้อมูลผู้ร่วมวิจัยคนที่ {index+1}</strong></p>
                  <p><strong>ชื่อ :</strong> {data.head_name_th}</p>
                  <p><strong>สัดส่วนการเข้าร่วมโครงการวิจัย :</strong> {data.join_per}</p>
                  <hr/>
                  </>
                ))}</>
                }
                
                <p>กรุณาเพิ่มสัดส่วนการวิจัยของท่านหรือผู้ร่วมวิจัยอีก {100-sumJoinPer} เปอร์เซ็นให้มีผลรวมครบ 100 เปอร์เซ็นต์</p>
              </Card>
              <br/>
              </>
            }
            {(sumJoinPer<100&&prodata?.budget_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา')&&<>
            <Card style={{marginBottom:10,backgroundColor:'#F54841'}}> 
            <p className='font-semibold' style={{color:'white'}}><u>คำเตือน</u></p>
              <p style={{color:'white'}}>ระบบได้ตรวจพบว่าท่านมีสัดส่วนการเข้าร่วมโครงการวิจัย {sumJoinPer} เปอร์เซ็นต์
                ซึ่งสัดส่วนโครงการวิจัยรวมไม่สามารถมีค่าเกิน 100 ได้
              </p>
              <p style={{color:'white'}}>กรุณาแก้ไขข้อมูลสัดส่วนงานวิจัยของท่านลง</p>
            </Card>
            </>}
            {(tmpheadjoinper==0||sumJoinPer!=100)&&
            <>
            {joinParticipant.length>0&&
              
              <Form.Item className='font-semibold' style={{marginLeft: '20px'}} name={'join_per'} label='สัดส่วนการเข้าร่วมโครงการวิจัย'
                rules={[{
                  validator: (_, value) =>
                    value <= 100-(joinParticipant.reduce((acc, data) => acc + (Number(data.join_per) || 0), 0)) ? Promise.resolve() : Promise.reject(new Error(`สัดส่วนการเข้าร่วมงานวิจัยไม่ควรมีจำนวนผลรวมเกิน 100 เปอร์เซ็นต์ ขณะนี้ท่านสามารถเพิ่มสัดส่วนงานวิจัยของท่านได้สูงสุด ${100-(joinParticipant.reduce((acc, data) => acc + (Number(data.join_per) || 0), 0))} เปอร์เซ็นต์ กรุณาแก้ไขสัดส่วนการเข้าร่วมวิจัยจากนักวิจัยร่วมของท่านก่อนหากต้องการแก้ไขข้อมูล`)),
                }]}>
                  <InputNumber
                    className="font-normal"
                    min={1}
                    addonBefore="ร้อยละ"
                    onChange={(value) => {
                      if (value && String(value).startsWith('0')) {
                        return null; // Prevent zero from being typed as the first digit
                      }
                    }}
                  />
                    </Form.Item>||
                <Form.Item className='font-semibold' style={{marginLeft: '20px'}} name={'join_per'} label='สัดส่วนการเข้าร่วมโครงการวิจัย'
                  rules={[{
                    validator: (_, value) =>
                      value <= 100 ? Promise.resolve() : Promise.reject(new Error(`สัดส่วนการเข้าร่วมงานวิจัยไม่ควรมีจำนวนผลรวมเกิน 100 เปอร์เซ็นต์`)),
                  },{
                    validator:(_, value)=> value != 0 ? Promise.resolve() : Promise.reject(new Error(`สัดส่วนการเข้าร่วมงานวิจัยไม่ควรมีค่าเป็น 0`)),
                  }]}>
                    <InputNumber
    className="font-normal"
    min={1}
    addonBefore="ร้อยละ"
    onChange={(value) => {
      if (value && String(value).startsWith('0')) {
        return null; // Prevent zero from being typed as the first digit
      }
    }}
  />
                  </Form.Item>}
                  </>

            ||
            <>{joinParticipant.length>0&&
              
          <Form.Item className='font-semibold' style={{marginLeft: '20px'}} name={'join_per'} label='สัดส่วนการเข้าร่วมโครงการวิจัย'
            rules={[{
              validator: (_, value) =>
                value <= 100-(joinParticipant.reduce((acc, data) => acc + (Number(data.join_per) || 0), 0)) ? Promise.resolve() : Promise.reject(new Error(`สัดส่วนการเข้าร่วมงานวิจัยไม่ควรมีจำนวนผลรวมเกิน 100 เปอร์เซ็นต์ ขณะนี้ท่านสามารถเพิ่มสัดส่วนงานวิจัยของท่านได้สูงสุด${100-(joinParticipant.reduce((acc, data) => acc + (Number(data.join_per) || 0), 0))} กรุณาแก้ไขสัดส่วนการเข้าร่วมวิจัยจากนักวิจัยร่วมของท่านก่อนแก้ไขข้อมูล `)),
            }]}>
              <InputNumber
    className="font-normal"
    min={1}
    addonBefore="ร้อยละ"
    onChange={(value) => {
      if (value && String(value).startsWith('0')) {
        return null; // Prevent zero from being typed as the first digit
      }
    }}
  />
            </Form.Item>
            ||<Form.Item className='font-semibold' style={{marginLeft: '20px'}} name={'join_per'} label='สัดส่วนการเข้าร่วมโครงการวิจัย'
            rules={[{
              validator: (_, value) =>
                value <= tmpheadjoinper ? Promise.resolve() : Promise.reject(new Error('สัดส่วนการเข้าร่วมงานวิจัยไม่ควรมีจำนวนผลรวมเกิน 100 เปอร์เซ็นต์ กรุณาแก้ไขสัดส่วนการเข้าร่วมวิจัยจากนักวิจัยร่วมของท่านก่อนแก้ไขข้อมูล')),
            }]}>

              <InputNumber
    className="font-normal"
    min={1}
    addonBefore="ร้อยละ"
    onChange={(value) => {
      if (value && String(value).startsWith('0')) {
        return null; // Prevent zero from being typed as the first digit
      }
    }}
  />
            </Form.Item>}
            </>}
            
            <Flex justify='space-between'><p className="font-semibold">วุฒิการศึกษา</p>
            <Button type='link'><a href="https://i.vu.ac.th/research/" target="_blank">กดที่นี่เพื่อไปแก้ไขข้อมูลของท่านในระบบMIS</a></Button>
            </Flex>
              <Table columns={
                [
                {
                  title: 'ระดับปริญญา',
                  dataIndex:'edu_level',
                  key: 'edu_level',
              },
              {   title: 'วุฒิการศึกษา',
                  dataIndex: 'edu_qual',
                  key: 'edu_qual',
              },
              {
                  title: 'สถาบันการศึกษา',
                  dataIndex:'edu_name',
                  key: 'edu_name',
              },
              {
                title: 'ปีที่สำเร็จการศึกษา',
                dataIndex:'edu_year',
                key: 'edu_year',
            },
              {
                  title: 'ประเทศ',
                  dataIndex:'edu_country',
                  key: 'edu_country'
                  ,
                  render:(_,record)=>(<>
                    {record.edu_country === '' && 
                    <Input/>
                    ||<p>{record.edu_country}</p>}
                    </>
                  )
              },
              ]} 
              locale={{
                emptyText: (
                  <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                ),
              }}
              dataSource={education} />


              <Flex justify='space-between' style={{marginBottom:20}}><p className='font-semibold'>ประสบการณ์ในการวิจัย</p><Button onClick={showModal}>เลือกข้อมูลจากระบบบริหารจัดการงานวิจัย มว.
              </Button></Flex>
              <Modal
                  title="ข้อมูลที่ต้องการเลือก"
                  width={1300}
                  open={open}
                  onOk={handleOk}
                  confirmLoading={confirmLoading}
                  onCancel={handleCancel}
                  footer={[
                    <Button key="back" onClick={handleCancel}>
                      กลับ
                    </Button>,
                  ]}
                >
                  <Tabs 
                    defaultActiveKey="1" 
                    items={[
                      {
                        key: '1',
                        label: 'โครงการที่มีฐานะหัวหน้าโครงการวิจัย',
                        children: (
                          <>
                            <Table 
                              columns={[
                                {
                                  title: 'ปี พ.ศ.',
                                  dataIndex: 'year',
                                  key: 'year',
                                },
                                {
                                  title: 'ชื่อเรื่องวิจัย',
                                  dataIndex: 'project_name',
                                  key: 'project_name',
                                },
                                {
                                  title: 'แหล่งทุนสนับสนุน',
                                  dataIndex: 'project_budget',
                                  key: 'project_budget',
                                  render: (_, record) => (
                                    <Space size="middle">
                                      {record.project_budget_type.inside && <p>{record.project_budget_type.inside}</p>}
                                      {record.project_budget_type.other && <p>{record.project_budget_type.other}</p>}
                                      {record.project_budget_type.student && <p>{record.project_budget_type.student}</p>}
                                    </Space>
                                  ),
                                },
                                {
                                  title: (
                                    <Checkbox
                                      onChange={handleSelectAll}
                                      checked={
                                        resHis.every(item =>
                                          selectedreshis.some(selected => selected.project_id === item.project_id)
                                        ) // All items selected
                                      }
                                      indeterminate={
                                        selectedreshis.some(selected =>
                                          resHis.some(item => selected.project_id === item.project_id)
                                        ) &&
                                        !resHis.every(item =>
                                          selectedreshis.some(selected => selected.project_id === item.project_id)
                                        ) // Some items selected
                                      }
                                      
                                    >
                                      <p style={{ color: 'white' }}>เลือกโครงการทั้งหมด</p>
                                    </Checkbox>
                                  ),
                                  key: 'action',
                                  render: (_, record) => (
                                    <Space size="middle">
                                      <Checkbox
                                        onChange={() => handleCheckboxChange({ ...record, role: 'หัวหน้าโครงการวิจัย' })}
                                        checked={selectedreshis.some(item => item.project_id === record.project_id)}
                                      />
                                    </Space>
                                  ),
                                },
                              ]} 
                              locale={{
                                emptyText: (
                                  <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                                ),
                              }}
                              dataSource={resHis.map(item => ({ ...item, role: 'หัวหน้าโครงการวิจัย' }))} 
                            />
                          </>
                        ),
                      },
                      {
                        key: '2',
                        label: 'โครงการที่เป็นผู้ร่วมโครงการวิจัย',
                        children: (
                          <>
                            <Table
                              columns={[
                                {
                                  title: 'ปี พ.ศ.',
                                  dataIndex: 'year',
                                  key: 'year',
                                },
                                {
                                  title: 'ชื่อเรื่องวิจัย',
                                  dataIndex: 'project_name',
                                  key: 'project_name',
                                },
                                {
                                  title: 'แหล่งทุนสนับสนุน',
                                  dataIndex: 'project_budget',
                                  key: 'project_budget',
                                  render: (_, record) => (
                                    <Space size="middle">
                                      {record.project_budget_type.inside && <p>{record.project_budget_type.inside}</p>}
                                      {record.project_budget_type.other && <p>{record.project_budget_type.other}</p>}
                                      {record.project_budget_type.student && <p>{record.project_budget_type.student}</p>}
                                    </Space>
                                  ),
                                },
                                {
                                  title: (
                                    <Checkbox
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setSelectedResHis(prevSelected => [
                                            ...prevSelected,
                                            ...JoinedRes.filter(item => !prevSelected.some(selected => selected.project_id === item.project_id))
                                              .map(item => ({ ...item, role: 'ผู้ร่วมโครงการวิจัย' }))
                                          ]);
                                        } else {
                                          setSelectedResHis(prevSelected =>
                                            prevSelected.filter(selected => !JoinedRes.some(item => item.project_id === selected.project_id))
                                          );
                                        }
                                      }}
                                      checked={JoinedRes.every((item) => selectedreshis.some(selected => selected.project_id === item.project_id))}
                                      indeterminate={
                                        selectedreshis.length > 0 &&
                                        selectedreshis.length < JoinedRes.length &&
                                        JoinedRes.some((item) => selectedreshis.includes(item))
                                      }
                                    >
                                      <p style={{color:'white'}}>เลือกโครงการทั้งหมด</p>
                                    </Checkbox>
                                  ),
                                  key: 'action',
                                  render: (_, record) => (
                                    <Space size="middle">
                                      <Checkbox
                                        onChange={() => handleCheckboxChange({ ...record, role: 'ผู้ร่วมโครงการวิจัย' })}
                                        checked={selectedreshis.some(item => item.project_id === record.project_id)}
                                      />
                                    </Space>
                                  ),
                                },
                              ]}
                              locale={{
                                emptyText: (
                                  <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                                ),
                              }}
                              dataSource={JoinedRes.map(item => ({ ...item, role: 'ผู้ร่วมโครงการวิจัย' }))} 
                            />
                          </>
                        ),
                      },
                    ]} 
                  />


  <Flex justify="flex-start">
    <p>ไม่มีข้อมูลที่ท่านต้องการ ? </p> &nbsp;
    <Button>
      <a href="https://i.vu.ac.th/research/" target="_blank">เพิ่มข้อมูลงานที่วิจัยที่ถูกตีพิมพ์</a>
    </Button>&nbsp;
    <Button
      icon={<ReloadOutlined />}
      onClick={() => refreshTable(sessionStorage.getItem('user'), 'res', 'head')}
      type="text"
    />
  </Flex>
          </Modal>

          <Table columns=
          {[{
              title: 'ปี พ.ศ.',
              dataIndex:'year',
              key: 'year'
          },
          {   title: 'ชื่อเรื่องวิจัย',
              dataIndex: 'project_name',
              key: 'project_name',
          },{
            title: 'สถานะในโครงการ',
            dataIndex: 'role',
            key: 'role',
          },
          {
            title: 'รายชื่อคณะวิจัย',
            dataIndex: 'join_project',
            key: 'join_project',
            width: 380,
            render: (_, record) => (
              <>
                {record.join_project.length!==0 &&
                  <>
                  <p>{record?.fullname}</p>
                  {record.join_project.map((item)=>(
                    <><p>{item.Per_FNameTH} {item.Per_LNameTH}</p></>
                    
                  ))}</>||<><Flex justify='center'>
                  <p>ไม่มีผู้ร่วมวิจัย</p></Flex>
                  </>
                }
            </>
            ),
          },{
            title:'แหล่งทุนสนับสนุน',
            dataIndex: 'project_budget_type',
            key: 'project_budget_type',
            render: (_, record) => (
              <Space size="middle">
                {record.project_budget_type.inside!=null&&<p>{record.project_budget_type.inside}</p>}
                {record.project_budget_type.other!=null&&<p>{record.project_budget_type.other}</p>}
                {record.project_budget_type.student!=null&&<p>{record.project_budget_type.student}</p>}
            </Space>
            ),
          },{
            title:'',
            dataIndex:'action',
            render:(_,record)=>(
          <><Tooltip title="ลบข้อมูลในตาราง">
          <Button type='primary' onClick={showDelResModal} danger value={record.project_id}>
              <DeleteOutlined />
            </Button></Tooltip>
              {/* onClick={DeleteHandle} */}
              <Modal
              title="ยืนยันการลบ"
              open={delResModal}
              onOk={handleOk}
              confirmLoading={confirmLoading}
              onCancel={handleCancel}
              footer={[
                <Button key="back" onClick={handleCancel}>
                  ยกเลิก
                </Button>,
                <Button key="submit" type="primary" loading={loading} onClick={()=>(handleDelRes(record.project_id))} value={record.project_id}>
                ตกลง
                </Button>
              ]}
            >
              <p>คุณต้องการลบข้อมูลดังกล่าวหรือไม่</p>
              <p>หมายเหตุ นี่เป็นเพียงการลบงานออกจากฟอร์มนี้เท่านั้น งานวิจัยของท่านจะยังคงอยู่ในระบบ</p>
            </Modal>
              </>
            )
          }
          ]} 
          locale={{
            emptyText: (
              <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
            ),
          }}
          dataSource={selectedreshis}/>
          <Flex justify='space-between' style={{marginBottom:20}}>
            <p className='font-semibold'>การตีพิมพ์เผยแพร่งานวิจัย</p><Button onClick={showPubModal}>เลือกข้อมูลจากระบบบริหารจัดการงานวิจัย มว.</Button></Flex>
          
        <Table columns={[
          {
            title: 'ปีที่พิมพ์',
            dataIndex:'year',
            key: 'year'
        },{
          title: 'ชื่อบทความทางวิชาการ',
          dataIndex:'academic_name',
          key: 'academic_name'
      },{
        title: 'ชื่อบทความทางวิชาการภาษาอังกฤษ',
        dataIndex:'academic_en_name',
        key: 'academic_en_name'
    },
        {
          title: 'ประเภทสิ่งตีพิมพ์',
          dataIndex:'academic_datebase',
          key: 'academic_datebase'
        },
        {
          title:'',
          dataIndex:'action',
          render:(_,record)=>(
        <><Tooltip title="ลบข้อมูลในตาราง">
        <Button type='primary' onClick={showDelAcaModal} danger value={record.academic_id}><DeleteOutlined /></Button>
            </Tooltip>{/* onClick={DeleteHandle} */}
            <Modal
            title="ยืนยันการลบ"
            open={delAcaModal}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            footer={[
              <Button key="back" onClick={handleCancel}>
                ยกเลิก
              </Button>,
              <Button key="submit" type="primary" loading={loading} onClick={()=>{handledelok(record.academic_id)}} value={record.academic_id}>
              ตกลง
              </Button>
            ]}
          >
            <p>คุณต้องการลบข้อมูลการตีพิมพ์งานวิจัยดังกล่าวหรือไม่</p>
            <p>หมายเหตุ นี่เป็นเพียงการลบงานออกจากฟอร์มนี้เท่านั้น งานวิจัยของท่านจะยังคงอยู่ในระบบ</p>
          </Modal>
            </>
          )
        }
      
    ]}
    locale={{
      emptyText: (
        <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
      ),
    }} 
    
    dataSource={selectedAcaHis} />
      
      {/* งานตีพิมพ์ */}

      {/* เลือกงานตีพิมพ์ */}
        <Modal
        title="ข้อมูลที่ต้องการเลือก"
        width={1300}
        open={openPub}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            กลับ
          </Button>,
          
        ]}>
          <Table columns={academicHis} 
          locale={{
            emptyText: (
              <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
            ),
          }} dataSource={acaHis}/>
          <Flex justify='flex-start'><p>ไม่มีข้อมูลที่ท่านต้องการ ? </p> 
          <Button onClick={AddAca}><a href="https://i.vu.ac.th/research/" target="_blank">เพิ่มข้อมูลงานที่วิจัยที่ถูกตีพิมพ์</a></Button>
          <Button
            icon={<ReloadOutlined />}
            onClick={() => refreshTable(sessionStorage.getItem('user'), 'res', 'head')}
            type="text"
          />
          </Flex>
          </Modal>
            <Flex justify='flex-end' style={{marginTop:10}}>
              {education.length==0&&<Button style={{marginBottom:20,backgroundColor:'#33b249',color:'white',borderColor:'#33b249'}} htmlType="submit" disabled>บันทึกข้อมูลหัวหน้าโครงการและไปส่วนถัดไป</Button>||<Button style={{marginBottom:20,backgroundColor:'#33b249',color:'white',borderColor:'#33b249'}} htmlType="submit">บันทึกข้อมูลหัวหน้าโครงการและไปส่วนถัดไป</Button>}
            </Flex>
          </Form>
        </div>
      ),
    },
    {
      title: 'ที่ปรึกษาโครงการ',
      content: (<div style={{
        marginTop:30
      }}>
        <Flex><p className="text-2xl font-bold " style={{marginTop:10,marginLeft:10}}>ข้อมูลที่ปรึกษาโครงการ</p>
        <Button onClick={()=>setSearch(true)} icon={<SearchOutlined />}/></Flex>
        <p className="text-s" style={{marginLeft:10}}>**หากโครงการของท่านไม่มีที่ปรึกษาโครงการให้กดถัดไป ไม่ต้องกรอกข้อมูล**</p>
        

        <Modal
        title="เพิ่มข้อมูลที่ปรึกษาโครงการจากภายในมหาวิทยาลัย"
        width={1000}
        open={opensearch}
        onCancel={handleCancel}
        footer={[
          <></>,
        ]}
        >
          <Form
          // onFinish={searchProf}
          onFinish={setProf}
          
          >           
          {/* <Form.Item label='รหัสวิจัยที่ต้องการค้นหา' name='ID'>
            <Input/>
          </Form.Item> */}
            

            <Form.Item label='กรุณาเลือกแผนกงานของที่ปรึกษาโครงการที่ท่านต้องการเพิ่ม' name='ID' >
            <Select
                  showSearch
                  style={{ width: 500 }}
                  value={SelectedOp}
                  onChange={handleChange}
                  options={Fac.map((Fac) => ({
                    value: Fac.Fac_ID,
                    label: Number(Fac.Fac_ID) === 40 ? 'คณะวิศวกรรมศาสตร์และสถาปัตยกรรม' : Fac.Fac_NameTH,
                    key: Fac.Fac_NameTH,
                  }))}
                  placeholder='กรุณาเลือกแผนกงานของที่ปรึกษาโครงการ'
                  filterOption={(input, option) =>
                    (option?.label as string).toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                />
            </Form.Item>
            {SelectedOp&&<Form.Item label='กรุณาเลือกที่ปรึกษาโครงการที่ท่านต้องการเพิ่ม' >
                <Select
                  showSearch
                  style={{ width: 500 }}
                  value = {prof}
                  onChange={handleProfChange}
                  placeholder='กรุณาเลือกที่ปรึกษาโครงการ'
                  options={ResOp.map((ResOp) => ({
                  value: ResOp.Per_PrefixTH +` ` +ResOp.Per_FNameTH + ` ` + ResOp.Per_LNameTH,
                  label: ResOp.Per_PrefixTH +` ` +ResOp.Per_FNameTH + ` ` + ResOp.Per_LNameTH,
                  key: ResOp.Per_PrefixTH +` ` +ResOp.Per_FNameTH + ` ` + ResOp.Per_LNameTH,
                }))}
                allowClear
                />
                </Form.Item>}
            <Flex justify='space-between'>
            <Button key="back" onClick={handleCancel}>
            กลับ
          </Button>
            <Button 
            type='primary'
            style={{ marginLeft: 20 }} 
            htmlType='submit' 
          >
            เพิ่มที่ปรึกษาโครงการ
          </Button></Flex>
          </Form>
          {/* {notselfprof&&<>
            <p>ท่านไม่สามารถเป็นที่ปรึกษาโครงการของตัวท่านเองได้</p>
          </>}
          {profnotfound&&<>
          <p>ระบบหาที่ปรึกษาโครงการที่ท่านกรอกไม่พบ</p>
          </>}
          {(foundprof&&tmpprof)&&<>
            <img src={tmpprof.picture}/>
            <p>ที่ปรึกษาโครงการที่พบ : {tmpprof.Per_PrefixTH} {tmpprof.Per_FNameTH} {tmpprof.Per_LNameTH}</p>
            <Button>เพิ่มที่ปรึกษาโครงการ</Button>
          </>} */}

          
        </Modal>
        
          <Form style={{marginBottom:60,marginRight:40,marginLeft:20}} onFinish={handleProfession} 
          form={form}
          >
            <Form.Item name={['pro_name']} className="font-semibold" label='ชื่อที่ปรึกษาโครงการ' >
              <Input className="font-normal" style={{marginLeft: '20px'}}/>
            </Form.Item>
            <Form.Item className="font-semibold"  label='ตำแหน่งทางวิชาการ' >
              <Select value={AcaPos} onChange={(value)=>setAcaPos(value)}>
                <Select.Option value="ศาสตราจารย์">ศาสตราจารย์</Select.Option>
                <Select.Option value="รองศาสตราจารย์">รองศาสตราจารย์</Select.Option>
                <Select.Option value="ผู้ช่วยศาสตราจารย์">ผู้ช่วยศาสตราจารย์</Select.Option>
                <Select.Option value="อาจารย์">อาจารย์</Select.Option>
                <Select.Option value="อื่นๆ">อื่นๆ</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item name={['pro_position']} label='โปรดระบุหากเลือกอื่นๆ' style={{marginLeft: '20px'}} className="" >
                <Input style={{marginLeft: '20px'}}/>
            </Form.Item>
            <Form.Item name={['pro_wp']} className="font-semibold" label='หน่วยงานที่สังกัด' >
              <Input className="font-normal" style={{marginLeft: '20px'}}/>
            </Form.Item><Form.Item name={['pro_exp']} className="font-semibold" label='ประสบการณ์ในการวิจัย' >
              <Input className="font-normal" style={{marginLeft: '20px'}}/>
            </Form.Item>
            <Flex justify='flex-end' style={{marginTop:50}}>
              <Button htmlType='submit' style={{backgroundColor:'#33b249',color:'white',borderColor:'#33b249'}}>บันทึกข้อมูลที่ปรึกษาโครงการ</Button>
            </Flex>
          </Form>
      </div>),
    },
    {
      title: 'ผู้ร่วมวิจัย',
      content: (
      <div id="part-1" style={{marginLeft:20,marginRight:20,marginBottom:20}} >
        {/* นักวิจัยร่วมโปรเจคหลัก */}
        {sumJoinPer==0&&<>
          <p>ทางระบบได้ตรวจสอบพบว่าท่านยังไม่ได้ทำการเพิ่มข้อมูลหัวหน้าวิจัยเข้าสู่ระบบ</p>
          <p>กรุณากลับไปกดบันทึกข้อมูลหัวหน้าโครงการวิจัยเข้าสู่ระบบก่อนที่จะเพิ่มข้อมูลผู้ร่วมวิจัย</p>
          <p></p>
        </>||<>{(sumJoinPer<100&&prodata?.budget_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา')&&<Card style={{marginLeft:20,marginTop:20,marginRight:20,marginBottom:20,backgroundColor:'#F5E898'}}>
          <p>ขณะนี้มีสัดส่วนการเข้าร่วมโครงการวิจัยทั้งหมด {sumJoinPer} เปอร์เซ็นต์ คงเหลือ {100-Number(sumJoinPer)} เปอร์เซ็นต์</p>
          <p>หากไม่มีผู้ร่วมวิจัย กรุณาใส่สัดส่วนการเข้าร่วมของท่านให้ครบ 100 เปอร์เซ็นต์</p>
        </Card>}
       {(sumJoinPer<100&&prodata?.budget_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา') && <><p className='font-semibold'>โครงการของท่านมีนักวิจัยร่วมหรือไม่</p>
          <Radio.Group className='normal' onChange={handleParticipantChange} value={participantcheck}>
            <Radio value={true} >มี</Radio>
            <Radio value={false}>ไม่มี</Radio>
          </Radio.Group>
          
          <br/>
        {/* ถ้ากดให้ขึ้น */}
        {participantcheck && (<>

      <Form 
        className='font-normal'
          onFinish={searchResearcher}
          onFinishFailed={(errorInfo) => console.log('Failed:', errorInfo)} // เพิ่ม error handler
        ><Flex>
          <Form.Item 
            label='กรุณากรอกรหัสผู้ช่วยวิจัย' 
            name="WK_ID" 
          >
            <Input style={{ marginLeft: 20, width: 200 }} />
          </Form.Item>
          <Button 
            style={{ marginLeft: 20 }} 
            htmlType='submit' 
          >
            ค้นหา
          </Button></Flex>
        </Form>
    <br/>

    {/* ข้อมูลนักวิจัย */}
    
      <>{searchparticipantcheck && tmpResearcher && (
      <>
        <img src={tmpResearcher.picture}></img>
        <p>นักวิจัยที่ต้องการเพิ่ม: {tmpResearcher.Per_FNameTH} {tmpResearcher.Per_LNameTH}</p>
        {(tmpEdu.length===0)&&
        <>
          <Card>
            <p>ทางระบบได้ตรวจสอบพบว่าผู้ร่วมวิจัยของท่านยังไม่มีข้อมูลดังต่อไปนี้ในระบบ 
              หากข้อมูลนี้มีความผิดพลาด กรุณาแจ้งให้ผู้ร่วมวิจัยของท่านตรวจสอบ <Button type='link' target="_blank" href='https://i.vu.ac.th/research/'>ระบบ MIS</Button> เพื่อเพิ่มข้อมูล
              หากผู้ร่วมวิจัยได้เพิ่มข้อมูลแล้ว ให้แจ้งผู้ดูแลระบบเพื่อตรวจสอบต่อไป
            </p>
            <><br/><Card style={{backgroundColor:'#F54841'}}>
                <p style={{color:'white'}}>ข้อมูลที่ท่านต้องเพิ่มในระบบ </p>
                <p style={{color:'white',marginLeft:20}}>- ข้อมูลวุฒิการศึกษา</p>
              </Card>
              {(tmpResHis.length==0||tmpjoinedResHis.length==0||tmpaca.length==0)&&<><br/>
                <Card style={{backgroundColor:'#F5E898'}}>
                  <p>ข้อมูลที่ท่านไม่มีในระบบ (หากผู้ร่วมวิจัยของท่านไม่เคยมีงานวิจัยหรืองานตีพิมพ์มาก่อน ท่านไม่จำเป็นต้องสนใจข้อความนี้ )</p>
                  {(tmpResHis.length==0&&tmpjoinedResHis.length==0)&&<p style={{marginLeft:20}}>- ประวัติข้อมูลงานวิจัย</p>}
                  {tmpaca.length==0&&<p style={{marginLeft:20}}>- ประวัติข้อมูลงานวิจัยตีพิมพ์</p>}
                </Card>
              </>}
              </>
          </Card>
        </>
        ||
        <>
        {((tmpResHis.length==0&&tmpjoinedResHis.length==0)||tmpaca.length==0)&&
        <>
          <Card>
            <p>ทางระบบได้ตรวจสอบพบว่าผู้ร่วมวิจัยของท่านยังไม่มีข้อมูลดังต่อไปนี้ในระบบ 
              หากข้อมูลนี้มีความผิดพลาด กรุณาแจ้งให้ผู้ร่วมวิจัยของท่านตรวจสอบระบบ MIS เพื่อเพิ่มข้อมูล
              หากผู้ร่วมวิจัยได้เพิ่มข้อมูลแล้ว ให้แจ้งผู้ดูแลระบบเพื่อตรวจสอบต่อไป
            </p>
            <Card style={{backgroundColor:'#F5E898'}}>
                  <p>ข้อมูลที่ท่านไม่มีในระบบ (หากท่านไม่เคยมีงานวิจัยหรืองานตีพิมพ์มาก่อน ท่านไม่ต้องสนใจข้อความนี้ )</p>
                  {(tmpResHis.length==0&&tmpjoinedResHis.length==0)&&<p style={{marginLeft:20}}>- ประวัติข้อมูลงานวิจัย</p>}
                  {tmpaca.length==0&&<p style={{marginLeft:20}}>- ประวัติข้อมูลงานวิจัยตีพิมพ์</p>}
                </Card>
          </Card>
        </>}
        <p>หากต้องการเปลี่ยนสามารถกรอกรหัสและกดค้นหาใหม่ได้ แต่หากข้อมูลถูกต้องแล้ว ให้กดปุ่มเพิ่มผู้ร่วมวิจัย</p> 
        <Button onClick={()=>{handleAddSearchParticipant(tmpResearcher)}}> เพิ่มผู้ร่วมวิจัยคนนี้ในโครงการ </Button>
        <br /></>
        }
      </>
    )}</>
    {participantchecknull && 
    <><Card style={{backgroundColor:'#F54841'}}>
    <p style={{color:'white'}}>ไม่พบผู้ช่วยวิจัยที่ตรงกับรหัสที่คุณกรอก   </p>
    </Card></>}
    {notInteger&&
    <><Card style={{backgroundColor:'#F54841'}}>
    <p style={{color:'white'}}>ข้อมูลที่ท่านกรอกไม่ใช่ตัวเลข   </p>
    </Card></>
    }
    {yourself&&
    <><Card style={{backgroundColor:'#F54841'}}>
    <p style={{color:'white'}}>  ท่านไม่สามารถเพิ่มตัวท่านเองเป็นผู้ร่วมโครงการวิจัยได้ </p>
    </Card></>
    }
    {Notexisted&&
     <><Card style={{backgroundColor:'#F54841'}}>
     <p style={{color:'white'}}>  ท่านไม่สามารถเพิ่มบุคลากรที่ออกจากมหาวิทยาลัยได้ </p>
     </Card></>
    }
    
    {/* ถ้าหาเจอให้ขึ้น */}

    {addResHis &&
      <>
      <hr/>
      <Flex justify='space-between'>
      <p className='text-xl font-semibold' style={{marginTop:20,marginBottom:20}}><u>ฟอร์มผู้ร่วมวิจัย</u></p>
      <Button danger type='primary' onClick={()=>{
        setaddResHis(false)
        setsearchparticipantcheck(false)
        console.log(tmpResearcher)
        if(tmpResearcher){
          console.log()
          setSumJoinPer(Number(sumJoinPer)+Number(settmpeditjoinper))
        }
      }}>ยกเลิกการเพิ่มนักวิจัย</Button></Flex>
      <Form 
      onFinish={AddHandle}
      form={subform}
      >
      <Form.Item className='font-semibold' style={{marginBottom:50}} name={['name_th']} label='ชื่อ-สกุล' layout="vertical">
        <Input className='font-normal' placeholder={`${tmpResearcher?.Per_PrefixTH} ${tmpResearcher?.Per_FNameTH} ${tmpResearcher?.Per_LNameTH}`} disabled style={{ width: 500 }} />
      </Form.Item>
      <Form.Item className='font-semibold' style={{marginBottom:50}} name={['name_en']} layout="vertical">
        <Input className='font-normal' placeholder={`${tmpResearcher?.Per_PrefixEN} ${tmpResearcher?.Per_FNameEN} ${tmpResearcher?.Per_LNameEN}`} disabled />
      </Form.Item>
      <Form.Item className='font-semibold' style={{marginBottom:50}} name={['join_per']} label='สัดส่วนการเข้าร่วมโครงการวิจัย' layout='horizontal'
      rules={[{
        validator: (_, value) =>
          value <= 100-Number(sumJoinPer) ? Promise.resolve() : Promise.reject(new Error(`จำนวนร้อยละรวมควรมีน้อยกว่าหรือเท่ากับ 100 ตอนนี้กรอกได้อีกเพียง ${100-sumJoinPer} เปอร์เซ็นต์เท่านั้น`)),
      }]}>
      <InputNumber
    className="font-normal"
    min={1}
    addonBefore="ร้อยละ"
    onChange={(value) => {
      if (value && String(value).startsWith('0')) {
        return null; // Prevent zero from being typed as the first digit
      }
    }}
  />
      </Form.Item>
      <Form.Item label='สถานที่ทำงาน' name={['wp']}>
        <Input className='font-normal' />
      </Form.Item>
      
      
      <Flex justify='space-between'><p className="font-semibold">วุฒิการศึกษา</p>
      </Flex>

    <Table columns={[
      {
        title: 'ระดับปริญญา',
        dataIndex:'edu_level',
        key: 'edu_level',
      },
      {
        title: 'วุฒิการศึกษา',
        dataIndex: 'edu_qual',
        key: 'edu_qual',
        
      },
      {
        title: 'สถาบันการศึกษา',
        dataIndex:'edu_name',
        key: 'edu_name',
      },
      {
        title: 'ปีที่สำเร็จการศึกษา',
        dataIndex: 'edu_year',
        key: 'edu_year',
        // render: (_, record, index) => (
        //   <>
        //   <InputNumber value={record.edu_year}
        //    min={0}    
        //    onChange={(value) => handletmpEduYearChange(index, Number(value))}/> 
        //     {/* {record.edu_year === null && 
        //       <p>ไม่มีข้อมูล</p>
        //       ||
        //       <p>{record.edu_year}</p>
        //     } */}
        //   </>
        // )
      },
      {
        title: 'ประเทศ',
        dataIndex:'edu_country',
        key: 'edu_country'
      }
    ]} 
    locale={{
      emptyText: (
        <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
      ),
    }}
    dataSource={tmpEdu} /><br />

    <Flex justify='space-between'>
      <p>ประสบการณ์ในการวิจัย</p>
      <Button onClick={showJoinRes} >เลือกข้อมูลจากระบบบริหารจัดการงานวิจัย มว.</Button>
    </Flex>
    <Modal
      title="ข้อมูลที่ต้องการเลือก"
      width={1300}
      open={openjoinRes}
      onOk={handleOk}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          กลับ
        </Button>
      ]}>
        <Tabs
  defaultActiveKey="1"
  items={[
    {
      key: '1',
      label: 'โครงการที่มีฐานะหัวหน้าโครงการวิจัย',
      children: (
        <>
          <Table 
            columns={[
              {
                title: 'ปี พ.ศ.',
                dataIndex: 'year',
                key: 'year'
              },
              {   
                title: 'ชื่อเรื่องวิจัย',
                dataIndex: 'project_name',
                key: 'project_name',
              },
              {
                title: 'แหล่งทุนสนับสนุน',
                dataIndex: 'project_budget',
                key: 'project_budget',
                render: (_, record) => (
                  <Space size="middle">
                    {record.project_budget_type.inside && <p>{record.project_budget_type.inside}</p>}
                    {record.project_budget_type.other && <p>{record.project_budget_type.other}</p>}
                    {record.project_budget_type.student && <p>{record.project_budget_type.student}</p>}
                  </Space>
                ),
              },
              {
                title: (
                  <Checkbox
                    onChange={(e) => {
                      if (e.target.checked) {
                        // Select all items, keeping already selected items
                        setselectedtmpResHis(prevSelected => [
                          ...prevSelected,
                          ...tmpResHis.filter(item => 
                            !prevSelected.some(selected => selected.project_id === item.project_id)
                          ).map(item => ({ ...item, role: 'หัวหน้าโครงการวิจัย' })) // Add role
                        ]);
                      } else {
                        // Deselect all items
                        setselectedtmpResHis(prevSelected =>
                          prevSelected.filter(selected => 
                            !tmpResHis.some(item => item.project_id === selected.project_id)
                          )
                        );
                      }
                    }}
                    checked={tmpResHis.every((item) => 
                      selectedtmpResHis.some(selected => selected.project_id === item.project_id)
                    )}
                    indeterminate={
                      selectedtmpResHis.length > 0 &&
                      selectedtmpResHis.length < tmpResHis.length &&
                      tmpResHis.some((item) => selectedtmpResHis.some(selected => selected.project_id === item.project_id))
                    }
                  >
                    <p style={{color:'white'}}>เลือกโครงการทั้งหมด</p>
                  </Checkbox>
                )
                ,
                key: 'action',
                render: (_, record) => (
                  <Space size="middle">
                    <Checkbox
                      onChange={() => handleJoinCheckboxChange({ ...record, role: 'หัวหน้าโครงการวิจัย' })} // Add role
                      checked={selectedtmpResHis.some(item => item.project_id === record.project_id)}
                    />
                  </Space>
                ),
              }
            ]} 
            locale={{
              emptyText: (
                <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
              ),
            }}
            dataSource={tmpResHis.map(item => ({ ...item, role: 'หัวหน้าโครงการวิจัย' }))} // Set role
          />
        </>
      )
    },
    {
      key: '2',
      label: 'โครงการที่เป็นผู้ร่วมโครงการวิจัย',
      children: (
        <>
          <Table 
            columns={[
              {
                title: 'ปี พ.ศ.',
                dataIndex: 'year',
                key: 'year'
              },
              {   
                title: 'ชื่อเรื่องวิจัย',
                dataIndex: 'project_name',
                key: 'project_name',
              },
              {
                title: 'แหล่งทุนสนับสนุน',
                dataIndex: 'project_budget',
                key: 'project_budget',
                render: (_, record) => (
                  <Space size="middle">
                    {record.project_budget_type.inside && <p>{record.project_budget_type.inside}</p>}
                    {record.project_budget_type.other && <p>{record.project_budget_type.other}</p>}
                    {record.project_budget_type.student && <p>{record.project_budget_type.student}</p>}
                  </Space>
                ),
              },
              {
                title: (
                  <Checkbox
                    onChange={(e) => {
                      if (e.target.checked) {
                        // Select all items, keeping already selected items
                        setselectedtmpResHis(prevSelected => [
                          ...prevSelected,
                          ...tmpjoinedResHis.filter(item => 
                            !prevSelected.some(selected => selected.project_id === item.project_id)
                          ).map(item => ({ ...item, role: 'ผู้ร่วมโครงการวิจัย' })) // Add role
                        ]);
                      } else {
                        // Deselect all items
                        setselectedtmpResHis(prevSelected =>
                          prevSelected.filter(selected => 
                            !tmpjoinedResHis.some(item => item.project_id === selected.project_id)
                          )
                        );
                      }
                    }}
                    checked={tmpjoinedResHis.every((item) => 
                      selectedtmpResHis.some(selected => selected.project_id === item.project_id))}
                    indeterminate={
                      selectedtmpResHis.some(selected =>
                        tmpjoinedResHis.some(item => selected.project_id === item.project_id)
                      )&&
                      !tmpjoinedResHis.every(item=>
                        selectedtmpResHis.some(selected => selected.project_id === item.project_id)
                      )
                      // selectedtmpResHis.length > 0 &&
                      // selectedtmpResHis.length < tmpjoinedResHis.length &&
                      // tmpjoinedResHis.some((item) => selectedtmpResHis.includes(item))
                    }
                  >
                    <p style={{color:'white'}}>เลือกโครงการทั้งหมด</p>
                  </Checkbox>
                ),
                key: 'action',
                render: (_, record) => (
                  <Space size="middle">
                    <Checkbox
                      onChange={() => handleJoinCheckboxChange({ ...record, role: 'ผู้ร่วมโครงการวิจัย' })} // Add role
                      checked={selectedtmpResHis.some(item => item.project_id === record.project_id)}
                    />
                  </Space>
                ),
              }
            ]} 
                          locale={{
                            emptyText: (
                              <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                            ),
                          }}
                          dataSource={tmpjoinedResHis.map(item => ({ ...item, role: 'ผู้ร่วมโครงการวิจัย' }))} // Set role
                        />
                      </>
                    )
                  }
                ]}
              />

      
    <Flex justify="flex-start"><p>ไม่มีข้อมูลที่ท่านต้องการ? กรุณาแจ้งผู้ร่วมวิจัยของท่านให้แก้ไขข้อมูลในตาราง</p> 
    <Button type='link'><a href="https://i.vu.ac.th/research/" target="_blank"><u>ที่นี่</u></a></Button>
    <Button
      icon={<ReloadOutlined />}
      onClick={()=>refreshTable(tmpid,'res','joined')}
      type="text"
    />
    </Flex>
    </Modal><br />
    <Table columns={[{
      title: 'ปี พ.ศ.',
      dataIndex: 'year',
      key: 'year'
    },
    {
      title: 'ชื่อเรื่องวิจัย',
      dataIndex: 'project_name',
      key: 'project_name',
    },{
      title: 'สถานะในโครงการ',
      dataIndex: 'role',
      key: 'role',
    },
     {
      title: 'รายชื่อคณะวิจัย',
      dataIndex: 'join_project',
      key: 'join_project',
      width: 380,
      render: (_, record) => (
        <>
          {record.join_project.length != 0 &&
            <>
              <p>{record?.fullname}</p>
              {record.join_project.map((item) => (
                <><p>{item.Per_PrefixTH}{item.Per_FNameTH} {item.Per_LNameTH}</p></>

              ))}</> || <><Flex justify='center'>
                <p>ไม่มีผู้ร่วมวิจัย</p></Flex>
            </>}
        </>
      ),
    }, {
      title: 'แหล่งทุนสนับสนุน',
      dataIndex: 'project_budget_type',
      key: 'project_budget_type',
      render: (_, record) => (
        <Space size="middle">
          {record.project_budget_type.inside != null && <p>{record.project_budget_type.inside}</p>}
          {record.project_budget_type.other != null && <p>{record.project_budget_type.other}</p>}
          {record.project_budget_type.student != null && <p>{record.project_budget_type.student}</p>}
        </Space>
      ),
    }, {
      title: '',
      dataIndex: 'action',
      render: (_, record) => (
        <><Tooltip title="ลบข้อมูลในตาราง"><Button type='primary' onClick={showDeljoinResModal} danger value={record.project_id}><DeleteOutlined /></Button>
          </Tooltip>{/* onClick={DeleteHandle} */}
          <Modal
            title="ยืนยันการลบ"
            open={delsubResModal}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            footer={[
              <Button key="back" onClick={handleCancel}>
                ยกเลิก
              </Button>,
              <Button key="submit" type="primary" loading={loading} onClick={()=>handlesubDel(record.project_id)} value={record.project_id}>
                ตกลง
              </Button>
            ]}
          >
            <p>คุณต้องการลบโครงการดังกล่าวหรือไม่</p>
          </Modal>
        </>
      )
    }
    ]} 
    locale={{
      emptyText: (
        <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
      ),
    }}
    dataSource={selectedtmpResHis} />
    <br /><Flex justify='space-between'><p>การตีพิมพ์เผยแพร่งานวิจัย</p>
    
    <Button onClick={()=>{setJoinAca(true)}}>เลือกข้อมูลจากระบบบริหารจัดการงานวิจัย มว.</Button></Flex>

    {/* ข้อมูลที่ถูกเลือกแล้ว */}
    <Table columns={[
      {
        title: 'ปีที่พิมพ์',
        dataIndex: 'year',
        key: 'year'
      }, {
        title: 'ชื่อบทความทางวิชาการ',
        dataIndex: 'academic_name',
        key: 'academic_name'
      },
      {
        title: 'ชื่อบทความทางวิชาการภาษาอังกฤษ',
        dataIndex: 'academic_en_name',
        key: 'academic_en_name'
      },
      {
        title: 'ประเภทสิ่งตีพิมพ์',
        dataIndex: 'academic_datebase',
        key: 'academic_datebase'
      },
      {
        title: '',
        dataIndex: 'action',
        render: (_, record) => (
          <><Tooltip title="ลบข้อมูลในตาราง"><Button type='primary' htmlType='reset' onClick={()=>setDelsubAcaModal(true)} danger value={record.academic_id}><DeleteOutlined /></Button>
            </Tooltip>{/* onClick={DeleteHandle} */}
            <Modal
              title="ยืนยันการลบ"
              open={delsubAcaModal}
              onOk={handleOk}
              confirmLoading={confirmLoading}
              onCancel={handleCancel}
              footer={[
                <Button key="back" onClick={handleCancel}>
                  ยกเลิก
                </Button>,
                <Button key="submit" type="primary" loading={loading} onClick={()=>handleDelsubPubRes(record.academic_id)} value={record.academic_id}>
                  ตกลง
                </Button>
              ]}
            >
              <p>คุณต้องการลบโครงการดังกล่าวหรือไม่</p>
            </Modal>
          </>
        )
      }
    ]} 
    locale={{
      emptyText: (
        <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
      ),
    }}
    dataSource={selectedTMPaca} />
    
    {/* โชว์ข้อมูลให้เลือก */}
    <Modal  
      title="ข้อมูลที่ต้องการเลือก"
      width={1300}
      open={openjoinaca}
      onOk={handleOk}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          กลับ
        </Button>
      ]}>
      <Table columns={academicJoinHis} locale={{
            emptyText: (
              <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
            ),
          }}
          dataSource={tmpaca} />

      <Flex justify="flex-start"><p>ไม่มีข้อมูลที่ท่านต้องการ? กรุณาแจ้งผู้ร่วมวิจัยของท่านให้แก้ไขข้อมูลในตาราง</p> 
    <Button type='link'><a href="https://i.vu.ac.th/research/" target="_blank"><u>ที่นี่</u></a></Button>
    <Button
            icon={<ReloadOutlined />}
            onClick={() => refreshTable(tmpid,'aca','joined')}
            type="text"
          />
    </Flex>
    </Modal>
    <br/>
    <Flex justify="flex-end">
      <Button htmlType="submit" style={{backgroundColor:'#33b249',color:'white'}}>บันทึกข้อมูลผู้ร่วมวิจัย</Button></Flex>
      <br/>
      </Form>
      </>
      
  }
      
      {/* สิ้นสุดตรงนี้ */}

      {/* tab test */}
      {
        <>
        {/* <Button onClick={handleAdd} 
        style={{ marginLeft: '20px', marginTop: '10px' }} 
        type='dashed' shape="round" icon={<PlusOutlined />}>
          เพิ่มผู้ร่วมวิจัย</Button> */}
          <Tabs>
            {joinParticipant.map((data,index)=>(
              <Tabs.TabPane tab={`ผู้ร่วมวิจัยคนที่ ${index+1}`} key={index}>
                <p>รหัสผู้ร่วมวิจัย : {data.head_id}</p>
                <p>ชื่อ : {data.head_name_th}</p>
                <p>สถานที่ทำงาน : {data.head_wp} </p>
                <p>สัดส่วนการเข้าร่วมโครงการวิจัย : {data.join_per}</p>
                <p className="font-semibold">วุฒิการศึกษา</p>
                <Table columns={[
                  {
                          title: 'ระดับปริญญา',
                          dataIndex:'edu_level',
                          key: 'edu_level',
                          
                  },
                  {   title: 'วุฒิการศึกษา',
                      dataIndex: 'edu_qual',
                      key: 'edu_qual',
                          
                      },
                      {
                          title: 'สถาบันการศึกษา',
                          dataIndex:'edu_name',
                          key: 'edu_name',
                          
                      },
                      {
                        title: 'ปีที่สำเร็จการศึกษา',
                        dataIndex:'edu_year',
                        key: 'edu_year',
                        
                    },
                      {
                          title: 'ประเทศ',
                          dataIndex:'edu_country',
                          key: 'edu_country'
                          ,
                      },
                      ]} 
                      
                      locale={{
                        emptyText: (
                          <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                        ),
                      }}
                      dataSource={JSON.parse(data.head_edu)}/>
                <p className="font-semibold"><u>ประสบการณ์ในการวิจัย</u></p>
                  <Table columns={[{
                      title: 'ปี พ.ศ.',
                      dataIndex:'year',
                      key: 'year'
                  },
                  {   title: 'ชื่อเรื่องวิจัย',
                      dataIndex: 'project_name',
                      key: 'project_name',
                  },{
                    title: 'สถานะในโครงการ',
                    dataIndex: 'role',
                    key: 'role',
                  },
                  {
                      title: 'รายชื่อคณะวิจัย',
                      dataIndex: 'join_project',
                      key: 'join_project',
                      width: 380,
                      render: (_, record) => (
                        <>
                          {record.join_project.length != 0 &&
                            <>
                              <p>{record?.fullname}</p>
                              {record.join_project.map((item: { Per_PrefixTH: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined; Per_FNameTH: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined; Per_LNameTH: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined; }) => (
                                <><p>{item.Per_PrefixTH}{item.Per_FNameTH} {item.Per_LNameTH}</p></>
                
                              ))}</> || <><Flex justify='center'>
                                <p>ไม่มีผู้ร่วมวิจัย</p></Flex>
                            </>}
                                    </>
                                  ),
                                },
                              {
                                title: 'แหล่งทุนสนับสนุน',
                                dataIndex:'project_budget',
                                key: 'project_budget',
                                render: (_, record) => (
                                  <Space size="middle">
                                    {record.project_budget_type.inside!=null&&<p>{record.project_budget_type.inside}</p>}
                                    {record.project_budget_type.other!=null&&<p>{record.project_budget_type.other}</p>}
                                    {record.project_budget_type.student!=null&&<p>{record.project_budget_type.student}</p>}
                                </Space>
                                ),
                            },]} 
                            locale={{
                              emptyText: (
                                <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                              ),
                            }}
                            
                            dataSource={JSON.parse(data.head_res)}/>
                      <p className="font-semibold"><u>การตีพิมพ์เผยแพร่งานวิจัย</u></p>
                        <Table columns={[
                                {
                                    title: 'ปีที่พิมพ์',
                                    dataIndex:'year',
                                    key: 'year'
                                },{
                                    title: 'ชื่อบทความทางวิชาการ',
                                    dataIndex:'academic_name',
                                    key: 'academic_name'
                                },{
                                  title: 'ชื่อบทความทางวิชาการภาษาอังกฤษ',
                                  dataIndex:'academic_en_name',
                                  key: 'academic_en_name'
                              },
                                {
                                    title: 'ประเภทสิ่งตีพิมพ์',
                                    dataIndex:'academic_datebase',
                                    key: 'academic_datebase'
                                },
                              ]} 
                              locale={{
                                emptyText: (
                                  <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                                ),
                              }}
                              dataSource={JSON.parse(data.head_pub)}/>
              <Flex justify='flex-end' style={{marginBottom:10}}><><Tooltip title="แก้ไขข้อมูลผู้ร่วมวิจัย">
              <Button onClick={()=>{editParticipant(data)}}> <a href='#part-1'><EditOutlined /></a></Button></Tooltip>
              &nbsp;
              <Tooltip title="ลบข้อมูลผู้ร่วมวิจัย">
              <Button type='primary' onClick={()=>{DeleteParticipant(data)
                console.log(data)
              }} danger><DeleteOutlined /></Button></Tooltip></></Flex>
              </Tabs.TabPane>
            ))

            }
          </Tabs>
          
          
          {/* สิ้นสุดตรงนี้ */}
          </>
      }
    </>)}</>||<><div style={{
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              height: '100%', // Set to a specific height if needed
              padding: '20px', // Optional padding
            }}><br/>
            {sumJoinPer==100&&<><p>โครงการของท่านไม่สามารถเพิ่มข้อมูลผู้ร่วมวิจัยได้แล้ว</p>
            <p>เนื่องจากสัดส่วนการร่วมวิจัยของท่านครบ{sumJoinPer}เปอร์เซ็นต์</p></>||<>
            <Card style={{backgroundColor:'#F54841'}}>
            <p style={{color:'white'}}>โครงการของท่านไม่สามารถเพิ่มข้อมูลผู้ร่วมวิจัยได้แล้ว</p>
            <p style={{color:'white'}}>เนื่องจากสัดส่วนการร่วมวิจัยของท่านมีผลรวม{sumJoinPer}เปอร์เซ็นต์</p>
            <p style={{color:'white'}}>กรุณาลดสัดส่วนการร่วมวิจัยของท่านหรือผู้ร่วมวิจัยลง {Number(sumJoinPer)-100} เปอร์เซ็นต์</p>
            </Card>
            </>}
            <br/>
            </div><div><Tabs>
            {joinParticipant.map((data,index)=>(
              <Tabs.TabPane tab={`ผู้ร่วมวิจัยคนที่ ${index+1}`} key={index}>
                <p>รหัสผู้ร่วมวิจัย : {data.head_id}</p>
                <p>ชื่อ : {data.head_name_th}</p>
                <p>สถานที่ทำงาน : {data.head_wp} </p>
                <p>สัดส่วนการเข้าร่วมโครงการวิจัย : {data.join_per}</p>
                <p className="font-semibold">วุฒิการศึกษา</p>
                <Table columns={[
                  {
                          title: 'ระดับปริญญา',
                          dataIndex:'edu_level',
                          key: 'edu_level',
                          
                  },
                  {   title: 'วุฒิการศึกษา',
                      dataIndex: 'edu_qual',
                      key: 'edu_qual',
                          
                      },
                      {
                          title: 'สถาบันการศึกษา',
                          dataIndex:'edu_name',
                          key: 'edu_name',
                          
                      },
                      {
                        title: 'ปีที่สำเร็จการศึกษา',
                        dataIndex:'edu_year',
                        key: 'edu_year',
                        
                    },
                      {
                          title: 'ประเทศ',
                          dataIndex:'edu_country',
                          key: 'edu_country'
                          ,
                      },
                      ]} 
                      locale={{
                        emptyText: (
                          <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                        ),
                      }}
                      dataSource={JSON.parse(data.head_edu)}/>
                <p className="font-semibold"><u>ประสบการณ์ในการวิจัย</u></p>
                  <Table columns={[{
                      title: 'ปี พ.ศ.',
                      dataIndex:'year',
                      key: 'year'
                  },
                  {   title: 'ชื่อเรื่องวิจัย',
                      dataIndex: 'project_name',
                      key: 'project_name',
                  },{
                    title: 'สถานะในโครงการ',
                    dataIndex: 'role',
                    key: 'role',
                  },
                  {
                      title: 'รายชื่อคณะวิจัย',
                      dataIndex: 'join_project',
                      key: 'join_project',
                      width: 380,
                      render: (_, record) => (
                        <>
                          {record.join_project.length != 0 &&
                            <>
                              <p>{record?.fullname}</p>
                              {record.join_project.map((item: { Per_PrefixTH: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined; Per_FNameTH: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined; Per_LNameTH: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined; }) => (
                                <><p>{item.Per_PrefixTH}{item.Per_FNameTH} {item.Per_LNameTH}</p></>
                
                              ))}</> || <><Flex justify='center'>
                                <p>ไม่มีผู้ร่วมวิจัย</p></Flex>
                            </>}
                                    </>
                                  ),
                                },
                              {
                                title: 'แหล่งทุนสนับสนุน',
                                dataIndex:'project_budget',
                                key: 'project_budget',
                                render: (_, record) => (
                                  <Space size="middle">
                                    {record.project_budget_type.inside!=null&&<p>{record.project_budget_type.inside}</p>}
                                    {record.project_budget_type.other!=null&&<p>{record.project_budget_type.other}</p>}
                                    {record.project_budget_type.student!=null&&<p>{record.project_budget_type.student}</p>}
                                </Space>
                                ),
                            },]} 
                            locale={{
                              emptyText: (
                                <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                              ),
                            }}
                            dataSource={JSON.parse(data.head_res)}/>
                      <p className="font-semibold"><u>การตีพิมพ์เผยแพร่งานวิจัย</u></p>
                        <Table columns={[
                                {
                                    title: 'ปีที่พิมพ์',
                                    dataIndex:'year',
                                    key: 'year'
                                },{
                                    title: 'ชื่อบทความทางวิชาการ',
                                    dataIndex:'academic_name',
                                    key: 'academic_name'
                                },{
                                  title: 'ชื่อบทความทางวิชาการภาษาอังกฤษ',
                                  dataIndex:'academic_en_name',
                                  key: 'academic_en_name'
                              },
                                {
                                    title: 'ประเภทสิ่งตีพิมพ์',
                                    dataIndex:'academic_datebase',
                                    key: 'academic_datebase'
                                },
                              ]} 
                              locale={{
                                emptyText: (
                                  <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                                ),
                              }}
                              dataSource={JSON.parse(data.head_pub)}/>
              <Flex justify='flex-end' style={{marginBottom:10}}><>
              {(sumJoinPer-Number(data.join_per)<100)&&<Tooltip title="แก้ไขข้อมูลนักวิจัยร่วม">
              <Button onClick={()=>{editParticipant(data)}}> <a href='#part-1'><EditOutlined /></a></Button></Tooltip>}
              &nbsp;
              <Tooltip title="ลบข้อมูลนักวิจัยร่วม">
              <Button type='primary' onClick={()=>{DeleteParticipant(data)}} danger><DeleteOutlined /></Button></Tooltip></></Flex>
              </Tabs.TabPane>
            ))

            }
          </Tabs></div></>}</>}
        


      </div>
      ),
    },
  ];

  const StudentSteps = [
    {
      title: (<>{prodata?.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'&&<p>อาจารย์ที่ปรึกษาโครงการวิจัย</p>||<p>หัวหน้าโครงการวิจัย</p>}</>),
      content: (
        <div>
          {((resHis.length==0&&JoinedRes.length==0)||acaHis.length==0||education.length==0)&&
          <Card
            style={{marginLeft:20,marginTop:20,marginBottom:20,marginRight:20
            }}>
              <Flex><p><u>คำเตือน</u></p> &nbsp; <p> ระบบได้ตรวจสอบพบว่าท่านยังขาดข้อมูลประวัติในระบบ MIS กรุณาเพิ่ม </p><Button type='link'><u>
                <a href="https://i.vu.ac.th/research/" target="_blank">ที่นี่</a></u></Button><p> ข้อมูลก่อนกรอกฟอร์มนี้</p> </Flex>
              {education.length==0&&<><br/><Card style={{backgroundColor:'#F54841'}}>
                <p style={{color:'white'}}>ข้อมูลที่ท่านต้องเพิ่มในระบบ </p>
                <p style={{color:'white',marginLeft:20}}>- ข้อมูลวุฒิการศึกษา</p>
              </Card></>}
              {
                (acaHis.length==0||resHis.length==0)&&
                <><br/>
                <Card style={{backgroundColor:'#F5E898'}}>
                  <p>ข้อมูลที่ท่านไม่มีในระบบ (หากท่านไม่เคยมีงานวิจัยหรืองานตีพิมพ์มาก่อน ท่านไม่ต้องสนใจข้อความนี้ )</p>
                  {(resHis.length==0&&JoinedRes.length==0)&&<p style={{marginLeft:20}}>- ประวัติข้อมูลงานวิจัย</p>}
                  {acaHis.length==0&&<p style={{marginLeft:20}}>- ประวัติข้อมูลงานวิจัยตีพิมพ์</p>}
                </Card>
                </>
              }
            </Card>}
          <h4 className="text-2xl font-bold " style={{marginLeft:10,marginTop:25}}>คณะผู้ดำเนินงานวิจัยสัดส่วนงานวิจัย</h4>
          {prodata?.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'&&<h5 className="text-xl font-semibold" style={{marginLeft:20}}>ประวัติอาจารย์ที่ปรึกษาโครงการ</h5>||<h5 className="text-xl font-semibold" style={{marginLeft:20}}>ประวัติหัวหน้าโครงการวิจัย</h5>}
          <Form style={{marginBottom:60,marginRight:40,marginLeft:40}} onFinish={HandleHead} form={form}>
            <Form.Item className='font-semibold' label='ชื่อ-สกุล' layout="vertical" >
              <Input className='font-normal'placeholder={`${User?.Per_PrefixTH} ${User?.Per_FNameTH} ${User?.Per_LNameTH}`} disabled value={String(sessionStorage.getItem("fullname"))}/>
            </Form.Item>
            <Form.Item layout="vertical" >
              <Input className='font-normal' style={{marginTop:15}} placeholder={`${User?.Per_PrefixEN} ${User?.Per_FNameEN} ${User?.Per_LNameEN}`} disabled value={`${User?.Per_PrefixEN} ${User?.Per_FNameEN} ${User?.Per_LNameEN}`}/>
            </Form.Item>
            <br/>
            <hr/>
            <br/>
            <Form.Item className='font-semibold' rules={[
                    { required: true, message: 'กรุณากรอกอีเมล' },
                    {
                    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: 'รูปแบบอีเมลไม่ถูกต้อง',
                    },
                ]} label='email' name={'head_email'} style={{marginLeft: '20px'}} >
              <AutoComplete
                onSearch={handleSearch}
                options={options}
                />
            </Form.Item>
            <Form.Item className='font-semibold' label='สถานที่ทำงาน' name={'head_wp'} style={{marginLeft: '20px'}} >
              <Input className='font-normal'/>
            </Form.Item>
            {(joinParticipant.length>0&&sumJoinPer==100)&&<><Card style={{marginBottom:10,backgroundColor:'#F5E898'}}>
              <p className='font-semibold'><u>คำเตือน</u></p>
              <p>ระบบได้ตรวจพบว่าท่านมีสัดส่วนการเข้าร่วมโครงการวิจัยรวมครบ 100 เปอร์เซ็นต์แล้ว</p>
              <p>เพื่อป้องกันไม่ให้สามารถบันทึกค่าเกินได้ ระบบจะทำการล็อคไม่ให้ท่านกรอกสัดส่วนมากกว่าที่กรอกไปแล้ว</p>
              <p>หากต้องการเพิ่มสัดส่วนของท่าน กรุณาลดสัดส่วนการร่วมวิจัยของผู้ร่วมวิจัยลงก่อน</p>
              </Card></>}
              {prodata?.budget_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'&&
                <>{(sumJoinPer<100&&prodata?.budget_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา')&&<>
              <Card>
                <p>ขณะนี้สัดส่วนการวิจัยรวมของโครงการนี้อยู่ที่ {sumJoinPer} เปอร์เซ็นต์</p>
                <p>โดยมีสัดส่วนการวิจัยของท่านอยู่ที่ {tmpheadjoinper} เปอร์เซ็นต์</p>
                {joinParticipant.length>0&&<><p>
                  และสัดส่วนการวิจัยของผู้ร่วมวิจัยอยู่ที่{" "}
                  {joinParticipant.reduce((acc, data) => acc + (Number(data.join_per) || 0), 0)} เปอร์เซ็นต์
                </p>
                {joinParticipant.map((data,index)=>(
                  <>
                  <hr/>
                  <p><strong>ข้อมูลผู้ร่วมวิจัยคนที่ {index+1}</strong></p>
                  <p><strong>ชื่อ :</strong> {data.head_name_th}</p>
                  <p><strong>สัดส่วนการเข้าร่วมโครงการวิจัย :</strong> {data.join_per}</p>
                  <hr/>
                  </>
                ))}</>
                }
                
                <p>กรุณาเพิ่มสัดส่วนการวิจัยของท่านหรือผู้ร่วมวิจัยอีก {100-sumJoinPer} เปอร์เซ็นให้มีผลรวมครบ 100 เปอร์เซ็นต์</p>
              </Card>
              <br/>
              </>
              }</>}
            
            {sumJoinPer>100&&<>
            <Card style={{marginBottom:10,backgroundColor:'#F54841'}}> 
            <p className='font-semibold' style={{color:'white'}}><u>คำเตือน</u></p>
              <p style={{color:'white'}}>ระบบได้ตรวจพบว่าท่านมีสัดส่วนการเข้าร่วมโครงการวิจัย {sumJoinPer} เปอร์เซ็นต์
                ซึ่งสัดส่วนโครงการวิจัยรวมไม่สามารถมีค่าเกิน 100 ได้
              </p>
              <p style={{color:'white'}}>กรุณาแก้ไขข้อมูลสัดส่วนงานวิจัยของท่านลง</p>
            </Card>
            </>}

            {prodata?.budget_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'&&<>
            {(tmpheadjoinper==0||sumJoinPer!=100)&&
            <>
            {joinParticipant.length>0&&
              <Form.Item className='font-semibold' style={{marginLeft: '20px'}} name={'join_per'} label='สัดส่วนการเข้าร่วมโครงการวิจัย'
                rules={[{
                  validator: (_, value) =>
                    value <= 100-(joinParticipant.reduce((acc, data) => acc + (Number(data.join_per) || 0), 0)) ? Promise.resolve() : Promise.reject(new Error(`สัดส่วนการเข้าร่วมงานวิจัยไม่ควรมีจำนวนผลรวมเกิน 100 เปอร์เซ็นต์ ขณะนี้ท่านสามารถเพิ่มสัดส่วนงานวิจัยของท่านได้สูงสุด ${100-(joinParticipant.reduce((acc, data) => acc + (Number(data.join_per) || 0), 0))} เปอร์เซ็นต์ กรุณาแก้ไขสัดส่วนการเข้าร่วมวิจัยจากนักวิจัยร่วมของท่านก่อนหากต้องการแก้ไขข้อมูล`)),
                }]}>
                  <InputNumber
                    className="font-normal"
                    min={1}
                    addonBefore="ร้อยละ"
                    onChange={(value) => {
                      if (value && String(value).startsWith('0')) {
                        return null; // Prevent zero from being typed as the first digit
                      }
                    }}
                  />
              </Form.Item>
              ||
                <Form.Item className='font-semibold' style={{marginLeft: '20px'}} name={'join_per'} label='สัดส่วนการเข้าร่วมโครงการวิจัย'
                  rules={[{
                    validator: (_, value) =>
                      value <= 100 ? Promise.resolve() : Promise.reject(new Error(`สัดส่วนการเข้าร่วมงานวิจัยไม่ควรมีจำนวนผลรวมเกิน 100 เปอร์เซ็นต์`)),
                  },{
                    validator:(_, value)=> value != 0 ? Promise.resolve() : Promise.reject(new Error(`สัดส่วนการเข้าร่วมงานวิจัยไม่ควรมีค่าเป็น 0`)),
                  }]}>
                    <InputNumber
                  className="font-normal"
                  min={1}
                  addonBefore="ร้อยละ"
                  onChange={(value) => {
                    if (value && String(value).startsWith('0')) {
                      return null; // Prevent zero from being typed as the first digit
                    }
                  }}
                />
                  </Form.Item>}
              </>
            ||
            <>{joinParticipant.length>0&&
              
          <Form.Item className='font-semibold' style={{marginLeft: '20px'}} name={'join_per'} label='สัดส่วนการเข้าร่วมโครงการวิจัย'
            rules={[{
              validator: (_, value) =>
                value <= 100-(joinParticipant.reduce((acc, data) => acc + (Number(data.join_per) || 0), 0)) ? Promise.resolve() : Promise.reject(new Error(`สัดส่วนการเข้าร่วมงานวิจัยไม่ควรมีจำนวนผลรวมเกิน 100 เปอร์เซ็นต์ ขณะนี้ท่านสามารถเพิ่มสัดส่วนงานวิจัยของท่านได้สูงสุด${100-(joinParticipant.reduce((acc, data) => acc + (Number(data.join_per) || 0), 0))} กรุณาแก้ไขสัดส่วนการเข้าร่วมวิจัยจากนักวิจัยร่วมของท่านก่อนแก้ไขข้อมูล `)),
            }]}>
              <InputNumber
                className="font-normal"
                min={1}
                addonBefore="ร้อยละ"
                onChange={(value) => {
                  if (value && String(value).startsWith('0')) {
                    return null; // Prevent zero from being typed as the first digit
                  }
                }}
              />
            </Form.Item>
            ||<Form.Item className='font-semibold' style={{marginLeft: '20px'}} name={'join_per'} label='สัดส่วนการเข้าร่วมโครงการวิจัย'
            rules={[{
              validator: (_, value) =>
                value <= tmpheadjoinper ? Promise.resolve() : Promise.reject(new Error('สัดส่วนการเข้าร่วมงานวิจัยไม่ควรมีจำนวนผลรวมเกิน 100 เปอร์เซ็นต์ กรุณาแก้ไขสัดส่วนการเข้าร่วมวิจัยจากนักวิจัยร่วมของท่านก่อนแก้ไขข้อมูล')),
            }]}>

              <InputNumber
                  className="font-normal"
                  min={1}
                  addonBefore="ร้อยละ"
                  onChange={(value) => {
                    if (value && String(value).startsWith('0')) {
                      return null; // Prevent zero from being typed as the first digit
                    }
                  }}
                />
            </Form.Item>}
            </>}</>}
            
            <Flex justify='space-between'><p className="font-semibold">วุฒิการศึกษา</p>
            <Button type='link'><a href="https://i.vu.ac.th/research/" target="_blank">กดที่นี่เพื่อไปแก้ไขข้อมูลของท่านในระบบMIS</a></Button>
            </Flex>
              <Table columns={
                [
                {
                  title: 'ระดับปริญญา',
                  dataIndex:'edu_level',
                  key: 'edu_level',
              },
              {   title: 'วุฒิการศึกษา',
                  dataIndex: 'edu_qual',
                  key: 'edu_qual',
              },
              {
                  title: 'สถาบันการศึกษา',
                  dataIndex:'edu_name',
                  key: 'edu_name',
              },
              {
                title: 'ปีที่สำเร็จการศึกษา',
                dataIndex:'edu_year',
                key: 'edu_year',
            },
              {
                  title: 'ประเทศ',
                  dataIndex:'edu_country',
                  key: 'edu_country'
                  ,
                  render:(_,record)=>(<>
                    {record.edu_country === '' && 
                    <Input/>
                    ||<p>{record.edu_country}</p>}
                    </>
                  )
              },
              ]} 
              locale={{
                emptyText: (
                  <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                ),
              }}
              dataSource={education} />


              <Flex justify='space-between' style={{marginBottom:20}}><p className='font-semibold'>ประสบการณ์ในการวิจัย</p><Button onClick={showModal}>เลือกข้อมูลจากระบบบริหารจัดการงานวิจัย มว.
              </Button></Flex>
              <Modal
                  title="ข้อมูลที่ต้องการเลือก"
                  width={1300}
                  open={open}
                  onOk={handleOk}
                  confirmLoading={confirmLoading}
                  onCancel={handleCancel}
                  footer={[
                    <Button key="back" onClick={handleCancel}>
                      กลับ
                    </Button>,
                  ]}
                >
                  <Tabs 
                    defaultActiveKey="1" 
                    items={[
                      {
                        key: '1',
                        label: 'โครงการที่มีฐานะหัวหน้าโครงการวิจัย',
                        children: (
                          <>
                            <Table 
                              columns={[
                                {
                                  title: 'ปี พ.ศ.',
                                  dataIndex: 'year',
                                  key: 'year',
                                },
                                {
                                  title: 'ชื่อเรื่องวิจัย',
                                  dataIndex: 'project_name',
                                  key: 'project_name',
                                },
                                {
                                  title: 'แหล่งทุนสนับสนุน',
                                  dataIndex: 'project_budget',
                                  key: 'project_budget',
                                  render: (_, record) => (
                                    <Space size="middle">
                                      {record.project_budget_type.inside && <p>{record.project_budget_type.inside}</p>}
                                      {record.project_budget_type.other && <p>{record.project_budget_type.other}</p>}
                                      {record.project_budget_type.student && <p>{record.project_budget_type.student}</p>}
                                    </Space>
                                  ),
                                },
                                {
                                  title: (
                                    <Checkbox
                                      onChange={handleSelectAll}
                                      checked={
                                        resHis.every(item =>
                                          selectedreshis.some(selected => selected.project_id === item.project_id)
                                        ) // All items selected
                                      }
                                      indeterminate={
                                        selectedreshis.some(selected =>
                                          resHis.some(item => selected.project_id === item.project_id)
                                        ) &&
                                        !resHis.every(item =>
                                          selectedreshis.some(selected => selected.project_id === item.project_id)
                                        ) // Some items selected
                                      }
                                      
                                    >
                                      <p style={{ color: 'white' }}>เลือกโครงการทั้งหมด</p>
                                    </Checkbox>
                                  ),
                                  key: 'action',
                                  render: (_, record) => (
                                    <Space size="middle">
                                      <Checkbox
                                        onChange={() => handleCheckboxChange({ ...record, role: 'หัวหน้าโครงการวิจัย' })}
                                        checked={selectedreshis.some(item => item.project_id === record.project_id)}
                                      />
                                    </Space>
                                  ),
                                },
                              ]} 
                              locale={{
                                emptyText: (
                                  <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                                ),
                              }}
                              dataSource={resHis.map(item => ({ ...item, role: 'หัวหน้าโครงการวิจัย' }))} 
                            />
                          </>
                        ),
                      },
                      {
                        key: '2',
                        label: 'โครงการที่เป็นผู้ร่วมโครงการวิจัย',
                        children: (
                          <>
                            <Table
                              columns={[
                                {
                                  title: 'ปี พ.ศ.',
                                  dataIndex: 'year',
                                  key: 'year',
                                },
                                {
                                  title: 'ชื่อเรื่องวิจัย',
                                  dataIndex: 'project_name',
                                  key: 'project_name',
                                },
                                {
                                  title: 'แหล่งทุนสนับสนุน',
                                  dataIndex: 'project_budget',
                                  key: 'project_budget',
                                  render: (_, record) => (
                                    <Space size="middle">
                                      {record.project_budget_type.inside && <p>{record.project_budget_type.inside}</p>}
                                      {record.project_budget_type.other && <p>{record.project_budget_type.other}</p>}
                                      {record.project_budget_type.student && <p>{record.project_budget_type.student}</p>}
                                    </Space>
                                  ),
                                },
                                {
                                  title: (
                                    <Checkbox
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setSelectedResHis(prevSelected => [
                                            ...prevSelected,
                                            ...JoinedRes.filter(item => !prevSelected.some(selected => selected.project_id === item.project_id))
                                              .map(item => ({ ...item, role: 'ผู้ร่วมโครงการวิจัย' }))
                                          ]);
                                        } else {
                                          setSelectedResHis(prevSelected =>
                                            prevSelected.filter(selected => !JoinedRes.some(item => item.project_id === selected.project_id))
                                          );
                                        }
                                      }}
                                      checked={JoinedRes.every((item) => selectedreshis.some(selected => selected.project_id === item.project_id))}
                                      indeterminate={
                                        selectedreshis.length > 0 &&
                                        selectedreshis.length < JoinedRes.length &&
                                        JoinedRes.some((item) => selectedreshis.includes(item))
                                      }
                                    >
                                      <p style={{color:'white'}}>เลือกโครงการทั้งหมด</p>
                                    </Checkbox>
                                  ),
                                  key: 'action',
                                  render: (_, record) => (
                                    <Space size="middle">
                                      <Checkbox
                                        onChange={() => handleCheckboxChange({ ...record, role: 'ผู้ร่วมโครงการวิจัย' })}
                                        checked={selectedreshis.some(item => item.project_id === record.project_id)}
                                      />
                                    </Space>
                                  ),
                                },
                              ]}
                              locale={{
                                emptyText: (
                                  <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                                ),
                              }}
                              dataSource={JoinedRes.map(item => ({ ...item, role: 'ผู้ร่วมโครงการวิจัย' }))} 
                            />
                          </>
                        ),
                      },
                    ]} 
                  />


  <Flex justify="flex-start">
    <p>ไม่มีข้อมูลที่ท่านต้องการ ? </p> &nbsp;
    <Button>
      <a href="https://i.vu.ac.th/research/" target="_blank">เพิ่มข้อมูลงานที่วิจัยที่ถูกตีพิมพ์</a>
    </Button>&nbsp;
    <Button
      icon={<ReloadOutlined />}
      onClick={() => refreshTable(sessionStorage.getItem('user'), 'res', 'head')}
      type="text"
    />
  </Flex>
          </Modal>

          <Table columns=
          {[{
              title: 'ปี พ.ศ.',
              dataIndex:'year',
              key: 'year'
          },
          {   title: 'ชื่อเรื่องวิจัย',
              dataIndex: 'project_name',
              key: 'project_name',
          },{
            title: 'สถานะในโครงการ',
            dataIndex: 'role',
            key: 'role',
          },
          {
            title: 'รายชื่อคณะวิจัย',
            dataIndex: 'join_project',
            key: 'join_project',
            width: 380,
            render: (_, record) => (
              <>
                {record.join_project.length!==0 &&
                  <>
                  <p>{record?.fullname}</p>
                  {record.join_project.map((item)=>(
                    <><p>{item.Per_FNameTH} {item.Per_LNameTH}</p></>
                    
                  ))}</>||<><Flex justify='center'>
                  <p>ไม่มีผู้ร่วมวิจัย</p></Flex>
                  </>
                }
            </>
            ),
          },{
            title:'แหล่งทุนสนับสนุน',
            dataIndex: 'project_budget_type',
            key: 'project_budget_type',
            render: (_, record) => (
              <Space size="middle">
                {record.project_budget_type.inside!=null&&<p>{record.project_budget_type.inside}</p>}
                {record.project_budget_type.other!=null&&<p>{record.project_budget_type.other}</p>}
                {record.project_budget_type.student!=null&&<p>{record.project_budget_type.student}</p>}
            </Space>
            ),
          },{
            title:'',
            dataIndex:'action',
            render:(_,record)=>(
          <><Tooltip title="ลบข้อมูลในตาราง">
          <Button type='primary' onClick={showDelResModal} danger value={record.project_id}>
              <DeleteOutlined />
            </Button></Tooltip>
              {/* onClick={DeleteHandle} */}
              <Modal
              title="ยืนยันการลบ"
              open={delResModal}
              onOk={handleOk}
              confirmLoading={confirmLoading}
              onCancel={handleCancel}
              footer={[
                <Button key="back" onClick={handleCancel}>
                  ยกเลิก
                </Button>,
                <Button key="submit" type="primary" loading={loading} onClick={()=>(handleDelRes(record.project_id))} value={record.project_id}>
                ตกลง
                </Button>
              ]}
            >
              <p>คุณต้องการลบข้อมูลดังกล่าวหรือไม่</p>
              <p>หมายเหตุ นี่เป็นเพียงการลบงานออกจากฟอร์มนี้เท่านั้น งานวิจัยของท่านจะยังคงอยู่ในระบบ</p>
            </Modal>
              </>
            )
          }
          ]} 
          locale={{
            emptyText: (
              <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
            ),
          }}
          dataSource={selectedreshis}/>
          <Flex justify='space-between' style={{marginBottom:20}}>
            <p className='font-semibold'>การตีพิมพ์เผยแพร่งานวิจัย</p><Button onClick={showPubModal}>เลือกข้อมูลจากระบบบริหารจัดการงานวิจัย มว.</Button></Flex>
          
        <Table columns={[
          {
            title: 'ปีที่พิมพ์',
            dataIndex:'year',
            key: 'year'
        },{
          title: 'ชื่อบทความทางวิชาการ',
          dataIndex:'academic_name',
          key: 'academic_name'
      },{
        title: 'ชื่อบทความทางวิชาการภาษาอังกฤษ',
        dataIndex:'academic_en_name',
        key: 'academic_en_name'
    },
        {
          title: 'ประเภทสิ่งตีพิมพ์',
          dataIndex:'academic_datebase',
          key: 'academic_datebase'
        },
        {
          title:'',
          dataIndex:'action',
          render:(_,record)=>(
        <><Tooltip title="ลบข้อมูลในตาราง">
        <Button type='primary' onClick={showDelAcaModal} danger value={record.academic_id}><DeleteOutlined /></Button>
            </Tooltip>{/* onClick={DeleteHandle} */}
            <Modal
            title="ยืนยันการลบ"
            open={delAcaModal}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            footer={[
              <Button key="back" onClick={handleCancel}>
                ยกเลิก
              </Button>,
              <Button key="submit" type="primary" loading={loading} onClick={()=>{handledelok(record.academic_id)}} value={record.academic_id}>
              ตกลง
              </Button>
            ]}
          >
            <p>คุณต้องการลบข้อมูลการตีพิมพ์งานวิจัยดังกล่าวหรือไม่</p>
            <p>หมายเหตุ นี่เป็นเพียงการลบงานออกจากฟอร์มนี้เท่านั้น งานวิจัยของท่านจะยังคงอยู่ในระบบ</p>
          </Modal>
            </>
          )
        }
      
    ]}
    locale={{
      emptyText: (
        <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
      ),
    }} 
    
    dataSource={selectedAcaHis} />
      
      {/* งานตีพิมพ์ */}

      {/* เลือกงานตีพิมพ์ */}
        <Modal
        title="ข้อมูลที่ต้องการเลือก"
        width={1300}
        open={openPub}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            กลับ
          </Button>,
          
        ]}>
          <Table columns={academicHis} 
          locale={{
            emptyText: (
              <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
            ),
          }} dataSource={acaHis}/>
          <Flex justify='flex-start'><p>ไม่มีข้อมูลที่ท่านต้องการ ? </p> 
          <Button onClick={AddAca}><a href="https://i.vu.ac.th/research/" target="_blank">เพิ่มข้อมูลงานที่วิจัยที่ถูกตีพิมพ์</a></Button>
          <Button
            icon={<ReloadOutlined />}
            onClick={() => refreshTable(sessionStorage.getItem('user'), 'res', 'head')}
            type="text"
          />
          </Flex>
          </Modal>
            <Flex justify='flex-end' style={{marginTop:10}}>
              {education.length==0&&<Button style={{marginBottom:20,backgroundColor:'#33b249',color:'white',borderColor:'#33b249'}} htmlType="submit" disabled>บันทึกข้อมูลหัวหน้าโครงการและไปส่วนถัดไป</Button>||<Button style={{marginBottom:20,backgroundColor:'#33b249',color:'white',borderColor:'#33b249'}} htmlType="submit">บันทึกข้อมูลหัวหน้าโครงการและไปส่วนถัดไป</Button>}
            </Flex>
          </Form>
        </div>
      ),
    },
    {
      title: 'รายชื่อผู้ร่วมโครงการ',
      content: (
      <div id="part-1" style={{marginLeft:20,marginRight:20,marginBottom:20,marginTop:20}} >
        <Card style={{justifyContent:'center'}}>
          <Flex justify='center'>
            <p style={{fontSize:'20',fontWeight:'bold'}}>กรุณาแนบรายชื่อผู้ร่วมวิจัยของท่านโดยใช้ฟอร์มด้านล่างนี้</p>
          </Flex>
          <br/>
          <Flex justify='center'>
            <a target='_blank' style={{color:'blue'}} href="https://docs.google.com/document/d/1fihobghbpgLqJhxmVJCnEnvVZbSyR7zQ/edit?usp=sharing&ouid=108248642863164545698&rtpof=true&sd=true">ดาวน์โหลดแบบฟอร์มแบ่งสัดส่วนงานของผู้ร่วมทำงานวิจัยเชิงนวัตกรรม สำหรับนักศึกษา</a>
          </Flex>
          <br/>

          <Flex justify='center'>
            <Upload {...props} 
              beforeUpload={beforeUpload}
              showUploadList={false}
              >
                  <Button icon={<UploadOutlined />}>อัพโหลดไฟล์</Button>
            </Upload>
          </Flex>
          <br/>
          <Flex justify='center'>
            <p>**ระบบรองรับแค่ไฟล์ PDF จำนวน 1 เท่านั้น**</p>
          </Flex>
          <br/>
          <List
              bordered
              dataSource={fileList}
              renderItem={(file) => (
                <List.Item
                  actions={[
                    <>
                      <Button type='link' onClick={() => DownloadHandle(file.uid)}>Download</Button>
                      <Button onClick={() =>{ console.log(file)
                        handleRemove(file.uid, file.fileName)}} type="link">Remove</Button>
                    </>
                  ]}
                >
                  <Button type='link' 
                  onClick={() => handlePreview(file)}>{file.name}</Button>
                  
                  <Modal
                   onCancel={()=>setOpenFile(false)}
                   style={{ width: 50000, height: 500 }}
                    open={openfile}
                    footer={<><Button onClick={()=>setOpenFile(false)} >ปิด</Button></>}
                    bodyStyle={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }} // Centering content
                  >
                    <br/>
                    {previewUrl ? (
                      <iframe
                        src={previewUrl}
                        width="100%"
                        height="600px"
                        title="PDF Viewer"
                      />
                    ) : (
                      <p>Loading...</p>
                    )}
                    
                  </Modal>
                </List.Item>
              )}
            />
          
        </Card>
      </div>
      ),
    },
  ]

  const maxlength = (prodata?.budget_type=='ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร'&&
    steps.length
    ||
    StudentSteps.length
  )

  

  const items = (prodata?.budget_type=='ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร'&&
          steps.map((item) => ({ key: item.title, title: item.title }))||
          StudentSteps.map((item) => ({ key: item.title, title: item.title }))
        )

    return(
        <div style={{
          padding:15
        }}>
          <h1 className="text-3xl font-semibold ">แบบฟอร์มเสนอโครงการงานวิจัยและนวัตกรรม</h1>  
          <p>เพื่อขอรับเงินทุนสนับสนุนงานวิจัยและนวัตกรรมจากมหาวิทยาลัยวงษ์ชวลิตกุล</p>
          <br/>
          <hr/>
          <br/>
            <h2 className="text-3xl font-bold ">ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</h2>
            <br/>
          <hr/>
          <br/>

          <Steps current={current} items={items} onChange={StepOnChange}/>
          {
            (prodata?.budget_type=='ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร')&&
            <div style={contentStyle}>{steps[current].content}</div>||
            <div style={contentStyle}>{StudentSteps[current].content}</div>
          }
          <div style={{ marginTop: 24 }}>
          {sumJoinPer>100&&<>
            <Card style={{backgroundColor:'#F54841'}}>
            <p className='font-semibold' style={{color:'white'}}><u>คำเตือน</u></p>
            <p style={{color:'white'}}>ระบบได้ตรวจสอบพบโครงการของท่านมีผลรวมสัดส่วนการเข้าร่วมงานวิจัยอยู่ที่ <u>{sumJoinPer}</u> ซึ่งสัดส่วนโครงการวิจัยรวมไม่สามารถมีค่าเกิน 100 ได้</p>
            <p style={{color:'white'}}>กรุณาลดสัดส่วนการร่วมวิจัยของท่านหรือผู้ร่วมวิจัยลง {Number(sumJoinPer)-100} เปอร์เซ็นต์เพื่อให้สัดส่วนวิจัยรวมมีค่าครบ 100 เปอร์เซ็นต์</p>
            </Card>
            <br/>
            </>}
            {((sumJoinPer<100&&prodata?.budget_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา')&&prodata?.budget_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา')&&<Card style={{marginLeft:20,marginTop:20,marginRight:20,marginBottom:20,backgroundColor:'#F5E898'}}>
            <p>ขณะนี้มีสัดส่วนการเข้าร่วมโครงการวิจัยทั้งหมด {sumJoinPer} เปอร์เซ็นต์ คงเหลือ {100-Number(sumJoinPer)} เปอร์เซ็นต์</p>
            <p>หากไม่มีผู้ร่วมวิจัย กรุณาใส่สัดส่วนการเข้าร่วมของท่านให้ครบ 100 เปอร์เซ็นต์</p>
          </Card>}
            <Flex justify='space-between'>
            
            {
              current==0 &&<><Button type="primary" onClick={() => navigate(`/VRIIS/Budget_req_About/${project_id}`)}>
              กลับส่วนที่ 1
            </Button>
            </>
            }
            {(current >0&&current<maxlength-1) &&<Button type="primary" onClick={() => prev()}>
                ก่อนหน้า
              </Button>}
            {/* {current === steps.length - 1 && (
              <Button type="primary" onClick={() => message.success('Processing complete!')}>
                บันทึกแล้วไปส่วนที่ 3
              </Button>
            )} */}
            <Button type="primary" onClick={handleMainInfo}>กลับหน้าหลัก</Button>
            
            {(current==maxlength-1)
            &&<>{(sumJoinPer==100||prodata?.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา')&&<><Button type="primary" onClick={handleNextPart}>ไปส่วนที่ 3</Button></>
            ||<><Tooltip title="คุณต้องมีเปอร์เซ็นต์การเข้าร่วมรวม100เปอร์เซ็นก่อนจะไปส่วนอื่น"><Button type="primary" disabled>ไปส่วนที่ 3</Button></Tooltip></>}</>||<Button type="primary" onClick={() => next()}>
            ถัดไป
          </Button>}
            </Flex>
            
            
          </div>
          

        </div>
    )
}










